<template>
  <div>
    <div style="margin-top: 20px">

      <Spinner :isLoading="isLoading" />

      <a ref="topSection" />

      <div class="container-fluid mt--6">
        <template v-if="!isQuoteOfferSent">
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">

              <div v-if="underwritingMessages.length == 0">
                <b-card class="uBind" data-tour="motor-new-existing">
                  <b-row>
                    <h2 class="secondary-card-header">
                      New or existing customer?
                    </h2>
                  </b-row>



                  <b-row>
                    <b-col md="12">
                      <base-input label="Would you like to create a quote for a new or existing customer?">
                        <button-radio-group @change="changeModeClicked($event)" id="btn-radios-1" v-model="formMode"
                          :options="[
                            {
                              label: 'New',
                              value: 'new',
                            },
                            {
                              label: 'Existing',
                              value: 'existing',
                            },

                          ]" name="radios-btn-default" buttons style="margin-top: 20px;"></button-radio-group>
                      </base-input>
                    </b-col>
                  </b-row>


                  <b-row v-if="formMode == 'existing'">
                    <b-col md="6">
                      <base-input name="Insured Name" label="Select Existing Customer" inputGroupClasses="uBind-input"
                        :rules="formRules.insuredName">
                        <el-select id="insuredDD" @blur="InsuredNameBlurred($event)"
                          @visible-change="visibleChange($event)" @keyup.native="setInsuredName($event)"
                          @change="selectCustomer($event)" v-model="model.insuredName" :rules="formRules.insuredName"
                          filterable placeholder="Search previous customers" v-cancel-read-only>
                          <el-option class="style-dropdown" v-for="(option, index) in customerList" :key="index"
                            :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                            :value="option.Customer_id">
                            <span>
                              <i
                                :class="option.Customer_email_opt_out ? 'fas fa-times text-danger' : 'fas fa-check text-success'"
                                class="mr-2"
                                aria-hidden="true"
                              ></i>
                              {{ option.Customer_insured_name }} ({{ option.Customer_contact_first_name }} {{ option.Customer_contact_last_name }})
                            </span>
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col md="6"> </b-col>
                  </b-row>

                </b-card>


                <b-card class="uBind" data-tour="motor-business-details">
                  <b-row>
                    <h2 class="secondary-card-header">
                      Business Details
                    </h2>
                  </b-row>



                  <b-row>
                    <b-col md="6">


                      <base-input label="Please enter the business name" placeholder="eg. ACME services"
                        v-model="model.insuredName" :disabled="fieldsDisabled.insuredName"
                        inputGroupClasses="uBind-input" />

                    </b-col>
                    <b-col md="6" style="margin-top:36px">
                      <base-button @click="searchBusiness()" type="danger" class="mb-4 bg-danger">Search</base-button>

                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <!-- <div>
                    <a class="abn-link" target="_blank" href="https://abr.business.gov.au/">Don't know the ABN?</a>
                  </div> -->
                      <base-input type="text" name="Insured ABN" label="Insured ABN" pattern="[0-9]{11}"
                        v-model="model.insuredABN" :disabled="fieldsDisabled.insuredABN" :rules="formRules.insuredABN"
                        prependIcon="fas fa-certificate" inputGroupClasses="uBind-input" />
                    </b-col>
                    <b-col md="2">
                      <!-- <div>
                    <a class="abn-link" target="_blank" href="https://abr.business.gov.au/">Don't know the ABN?</a>
                  </div> -->
                      <base-input type="text" name="Years in Business" label="Yrs in Business"
                        v-model="model.yrsInOperation" :disabled="true" inputGroupClasses="uBind-input" />
                    </b-col>
                    <b-col md="6">

                      <base-input name="Business Description" label="Business Description"
                        inputGroupClasses="uBind-input" :rules="formRules.equipmentDescription">
                        <el-select v-model="model.businessDesc" @change="quoteChanged">
                          <el-option v-for="option in businessDescriptionsOptions" :key="option.value"
                            :label="replaceAmp(option.label)" :value="option.value">
                          </el-option>
                        </el-select>

                      </base-input>
                    </b-col>
                  </b-row>
                </b-card>

                <b-card no-body class="uBind" data-tour="motor-contact-details">

                  <h2 class="secondary-card-header">Insured Details</h2>


                  <b-card-body>
                    <div v-html="certContents"></div>



                    <b-row>
                      <b-col md="6">
                        <base-input name="Contact First Name" label="Contact First Name" :rules="formRules.contactFName"
                          v-model="model.contactFName" :disabled="fieldsDisabled.contactFName" placeholder="John" />
                      </b-col>
                      <b-col md="6">
                        <base-input name="Contact Last Name" label="Contact Last Name" :rules="formRules.contactLName"
                          v-model="model.contactLName" :disabled="fieldsDisabled.contactLName" placeholder="Smith" />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <base-input label="Contact Phone Number" name="Contact Phone Number"
                          :rules="formRules.contactPhone" v-model="model.contactPhone"
                          :disabled="fieldsDisabled.contactPhone" />
                      </b-col>
                      <b-col md="6">
                        <base-input name="Contact Email" label="Contact Email" :rules="formRules.contactEmail"
                          v-model="model.contactEmail" :disabled="fieldsDisabled.contactEmail"
                          placeholder="john@example.com" />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12" class="mb-4 uBind-input">
                        <label for="addrs_1" class="form-control-label">
                          Search Insured Address
                        </label>
                        <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields"
                          class="form-control" id="addrs_1" v-model="model.insuredStreet"
                          :disabled="fieldsDisabled.insuredStreet" :rules="formRules.insuredStreet" />
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="4">
                        <base-input autocomplete="new-password" name="City" label="City" v-model="model.insuredCity"
                          :disabled="fieldsDisabled.insuredCity" :rules="formRules.insuredCity"
                          inputGroupClasses="uBind-input" />
                      </b-col>
                      <b-col md="4">

                        <base-input name="State" label="State" :rules="formRules.insuredState"
                          inputGroupClasses="uBind-input">
                          <el-select v-model="model.insuredState" :disabled="fieldsDisabled.insuredState">
                            <el-option v-for="option in states" :key="option.label" :label="option.label"
                              :value="option.value">
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="4">
                        <base-input autocomplete="new-password" name="Post Code" label="Postcode" type="number"
                          v-model="model.insuredPostcode" :disabled="fieldsDisabled.insuredPostcode"
                          inputGroupClasses="uBind-input" />
                      </b-col>
                    </b-row>

                  </b-card-body>
                </b-card>

                <b-card no-body class="uBind mb-4">

                  <h2 class="secondary-card-header">
                    Vehicle Details
                  </h2>

                  <!-- <h4>
                  Please enter the information below.
                </h4> -->

                  <b-card-body>

                    <!-- <b-row>
                  <b-col md="6">
                    <h3>
                      Principal Situation/Depot
                    </h3>
                  </b-col>
                  <b-col md="6" style="text-align: right;">
                    <base-button @click="copyAddress()" type="danger" class="mb-4 bg-danger">Copy from Insured
                      Address if the same</base-button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12" class="mb-4 uBind-input">
                    <label for="addrs_2" class="form-control-label">
                      Search Address
                    </label>
                    <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields"
                      class="form-control" id="addrs_2" v-model="model.situationStreet"
                      :disabled="fieldsDisabled.situationStreet" :rules="formRules.situationStreet" />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="4">
                    <base-input label="City" v-model="model.situationCity" :disabled="fieldsDisabled.situationCity"
                      :rules="formRules.situationCity" inputGroupClasses="uBind-input" />
                  </b-col>
                  <b-col md="4">

                    <base-input name="State" label="State" :rules="formRules.situationState"
                      inputGroupClasses="uBind-input">
                      <el-select v-model="model.situationState" :disabled="fieldsDisabled.situationState">
                        <el-option v-for="option in states" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input autocomplete="off" label="Postcode" type="number" v-model="model.situationPostcode"
                      :disabled="fieldsDisabled.situationPostcode" inputGroupClasses="uBind-input" />
                  </b-col>
                </b-row> -->


                    <b-row>
                      <b-col md="6">
                        <h3>
                          Vehicles
                        </h3>
                      </b-col>
                      <b-col md="6" style="text-align: right;">
                        <base-button v-if="model.vehicles.length > 0" @click="addVehicle()" type="danger"
                          class="mb-4 bg-danger">Add Vehicle</base-button>
                      </b-col>
                    </b-row>

                    <template v-if="model.vehicles.length > 0">

                      <b-row
                        style="font-size: 9pt; font-weight: bold; padding: 3px 0px 6px 0px; text-decoration: underline;">
                        <b-col class="less-padding" style="flex-basis: 18%;">
                          Vehicle Type
                        </b-col>


                        <!-- <b-col class="less-padding" style="flex-basis: 13%;">
                      Freight Task
                    </b-col> -->

                        <b-col class="less-padding" style="flex-basis: 5%; word-break: normal; overflow-wrap: normal;">
                          VIN / Registration

                        </b-col>

                        <!-- <b-col class="less-padding" style="flex-basis: 7%;">
                      Registration

                    </b-col> -->

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          Year

                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          Make

                        </b-col>
                        <b-col class="less-padding" style="flex-basis: 5%;">
                          Model
                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          Sum Insured

                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 7%;">
                          Sum Insured Type
                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          Excess
                        </b-col>
                        <!-- <b-col style="flex-basis: 5%;">
                    <base-input label="State" v-model="item.vehicle.vehicleState" inputGroupClasses="uBind-input" />

                  </b-col> -->
                        <b-col class="less-padding" style="flex-basis: 3%;">
                          Post Code

                        </b-col>
                        <b-col class="less-padding" style="flex-basis: 10px; align-content: center">

                        </b-col>


                      </b-row>

                      <b-row v-for="(item, index) in model.vehicles" :key="index" style="padding: 3px 0px 3px 0px;">

                        <b-col class="less-padding" style="flex-basis: 18%;">
                          <!-- <base-input name="Vehicle Type" :rules="formRules.vehicleType" inputGroupClasses="uBind-input">
                      <el-select v-model="item.vehicle.vehicleType" :disabled="fieldsDisabled.vehicleType">
                        <el-option v-for="option in vehicleTypeOptions" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input> -->

                          <div class="vehicleText">{{vehicleTypeOptions.find(f => f.value ==
                            item.vehicle.vehicleType).label}}
                          </div>
                        </b-col>


                        <!-- <b-col class="less-padding" style="flex-basis: 13%;">

                      <div class="vehicleText">{{freightTaskOptions.find(f => f.value ==
                        item.vehicle.freightTask).label}}
                      </div>

                    </b-col> -->

                        <b-col class="less-padding" style="flex-basis: 5%;">

                          <div class="vehicleText">{{ item.vehicle.motorwebGlasses.vin }} {{
                            item.vehicle.motorwebGlasses.registration }}</div>

                        </b-col>

                        <!-- <b-col class="less-padding" style="flex-basis: 7%;">
                      <div class="vehicleText">{{ item.vehicle.motorwebGlasses.registration }}</div>

                    </b-col> -->

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          <!-- <base-input v-model="item.vehicle.vehicleYear" inputGroupClasses="uBind-input" /> -->

                          <div class="vehicleText">{{ item.vehicle.vehicleYear }}</div>

                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          <!-- <base-input v-if="item.vehicle.vehicleType != 'SE1'" v-model="item.vehicle.motorwebGlasses.make"
                      inputGroupClasses="uBind-input" /> -->

                          <div class="vehicleText">{{ item.vehicle.motorwebGlasses.make }}</div>

                          <!-- <base-input v-if="item.vehicle.vehicleType == 'SE1'" name="Make" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select @change="item.vehicle.motorwebGlasses.family = ''"
                        v-model="item.vehicle.motorwebGlasses.make">
                        <el-option v-for="option in carModels" :key="option.Make" :label="option.Make"
                          :value="option.Make">
                        </el-option>
                      </el-select></base-input> -->




                        </b-col>
                        <b-col class="less-padding" style="flex-basis: 5%;">
                          <!-- <base-input name="Model" label="Model" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select v-model="item.model">
                        <el-option v-for="option in vehicleModelOptions" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select></base-input> -->

                          <div class="vehicleText">{{ item.vehicle.motorwebGlasses.family }}</div>

                          <!-- <base-input v-if="item.vehicle.vehicleType == 'SE1'" name="Family" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select v-model="item.vehicle.motorwebGlasses.family">
                        <el-option
                          v-for="option in (carModels.find(f => f.Make == item.vehicle.motorwebGlasses.make) ? carModels.find(f => f.Make == item.vehicle.motorwebGlasses.make).Models : [])"
                          :key="option" :label="option" :value="option">
                        </el-option>
                      </el-select></base-input> -->



                          <!-- <base-input v-if="item.vehicle.vehicleType != 'SE1'" v-model="item.vehicle.motorwebGlasses.family"
                      inputGroupClasses="uBind-input" /> -->


                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          <!-- <base-input v-model="item.vehicle.sumInsured" inputGroupClasses="uBind-input" /> -->

                          <div class="vehicleText">{{ formatCurrencyString(parseFloat(item.vehicle.sumInsured)) }}</div>

                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 7%;">
                          <div class="vehicleText">{{ getSumInsuredTypeLabel(item.vehicle.sumInsuredType) }}</div>
                        </b-col>

                        <b-col class="less-padding" style="flex-basis: 5%;">
                          <div class="vehicleText">{{ formatCurrencyString(parseFloat(item.vehicle.basicExcess)) }}
                          </div>

                        </b-col>
                        <!-- <b-col style="flex-basis: 5%;">
                    <base-input label="State" v-model="item.vehicle.vehicleState" inputGroupClasses="uBind-input" />

                  </b-col> -->
                        <b-col class="less-padding" style="flex-basis: 3%;">
                          <!-- <base-input v-model="item.vehicle.vehiclePostcode" inputGroupClasses="uBind-input" /> -->

                          <div class="vehicleText">{{ item.vehicle.vehiclePostcode }}</div>

                        </b-col>
                        <b-col class="less-padding"
                          style="align-content: center;flex-basis: 10px; padding: 0px; display: flex">
                          <base-button style="padding: 0px 5px 5px 5px; max-height: 30px;" class="bg-danger"
                            type="danger" icon @click="editVehicle(item, index)">
                            <b-icon font-scale="0.9" icon="pencil-square"></b-icon></base-button>
                          <base-button style="padding: 0px 5px 5px 5px;color: red; max-height: 30px;" class="bg-white"
                            type="danger" @click="removeVehicle(index)">
                            <b-icon font-scale="0.9" icon="trash"></b-icon></base-button>
                        </b-col>

                        <!-- <b-col md="4">

                <base-input name="State" label="State" :rules="formRules.insuredState" inputGroupClasses="uBind-input">
                  <el-select v-model="model.insuredState" :disabled="fieldsDisabled.insuredState">
                    <el-option v-for="option in states" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="4">
                <base-input autocomplete="off" label="Postcode" type="number" v-model="model.insuredPostcode"
                  :disabled="fieldsDisabled.insuredPostcode" inputGroupClasses="uBind-input" />
              </b-col> -->
                      </b-row>
                    </template>

                    <div v-if="peOnlyVehiclesNeedTowingVehicle"
                      style="width: 100%; font-size: 10pt; padding: 10px 0; color: #dc3545;">
                      You must add a motor vehicle – If no vehicle is added then we cannot proceed with a plant & equipment quote.
                    </div>

                    <div v-if="se1VehiclesFleetRequirementNotMet"
                      style="width: 100%; font-size: 10pt; padding: 10px 0; color: #dc3545;">
                      You must add at least 5 Sedan/4WD/Utility/Van vehicles, or at least one other motor vehicle, before we can proceed with this quote.
                    </div>

                    

                    <div>
                      <div v-if="model.vehicles == 0"
                        style="width: 100%;text-align: center;font-size: 10pt;padding: 10px;color: #fb6340">
                        Please add at least one vehicle or asset</div>
                    </div>


                    <b-row v-if="model.vehicles.length == 0">

                      <b-col md="12" style="text-align: center;">
                        <base-button data-tour="motor-add-vehicle" @click="addVehicle()" type="danger" class="mb-4 bg-danger">Add
                          Vehicle</base-button>
                      </b-col>
                    </b-row>




                    <!-- <b-row>
                <b-col md="6">

                  <base-input name="RegisteredGST" label="Registered for GST?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.registeredForGST">
                    </base-switch>
                  </base-input>

                </b-col>

              </b-row> -->
                    <!-- <b-row>
                <b-col md="6">
                  <base-input name="MoreThan50k"
                    label="Are there any of the items you are quoting worth more than $50,000 each?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.moreThan50k">
                    </base-switch>
                  </base-input>
                </b-col>

              </b-row> -->

                    <!-- <base-button @click="createNewQuote()" type="danger" class="mb-4 bg-danger">Create Quote</base-button> -->




                  </b-card-body>
                </b-card>

              </div>

              <b-card v-if="apiErrors.length > 0" class="uBind apiError">
                <h3>Error</h3>
                <h4>Please review the following errors.</h4>

                <div v-for="(item, index) in apiErrors" :key="index"
                  style="display: inline-flex; color: white; width: 100%;">
                  <div style="flex-basis: 200px;">Error Code: {{ item.errorCode }}</div>
                  <div style="flex-basis: 100%;">Error Description: {{ item.errorMessage }}</div>
                </div>

              </b-card>


              <b-card
                v-if="underwritingMessages.length > 0 && underwritingMessages.filter(f => f.messageType == 'REFERRAL').length > 0">

                <h3>Thankyou</h3>

                <div style="margin-bottom: 1.25rem;">Thankyou for submitting the quote. Unfortunately it has been marked
                  for referral,
                  due to the reasons
                  below. Our team has been notified and will be in touch shortly.</div>

              </b-card>

              <b-card
                v-if="underwritingMessages.length > 0 && underwritingMessages.filter(f => f.underwritingDecision == 'DECLINED').length > 0">

                <h3>Thankyou</h3>

                <div style="margin-bottom: 1.25rem;">Thankyou for submitting the quote. Unfortunately it has been
                  declined, due to the
                  reasons below.</div>

              </b-card>

              <b-card
                v-if="underwritingMessages.length > 0 && underwritingMessages.filter(f => f.messageType == 'REFERRAL').length == 0 && underwritingMessages.filter(f => f.underwritingDecision == 'DECLINED').length == 0">

                <h3>Thankyou</h3>

                <div style="margin-bottom: 1.25rem;">Thankyou for submitting the quote. Unfortunately we are unable to
                  proceed with this quote based on the underwriting outcome below.</div>

              </b-card>

              <b-card v-if="underwritingMessages.length > 0" class="uBind underWritingMessages">
                <h3>Underwriting messages</h3>
                <h4>Please review the following messages.</h4>

                <div v-for="(item, index) in underwritingMessages" :key="index"
                  style="display: inline-flex; color: white; width: 100%;">
                  <!-- <div style="flex-basis: 200px;">Type: {{ item.messageType }}</div> -->
                  <div style="flex-basis: 200px;">Status: {{ item.underwritingDecision }}</div>
                  <div style="flex-basis: 100%;">{{ item.text }}</div>
                </div>

              </b-card>

              <div class="text-center" v-if="underwritingMessages.length > 0">
                <base-button type="danger" class="mb-4 bg-danger" @click="goToMotorCreateQuote">
                  Create new Quote
                </base-button>
              </div>

              <b-card v-if="validationMessages.length > 0" class="uBind validationMessages">
                <h3>Validation messages</h3>
                <h4>Please review the following messages.</h4>

                <div v-for="(item, index) in validationMessages" :key="index"
                  style="display: inline-flex; color: white; width: 100%;">
                  <div style="flex-basis: 200px;">{{ item.messageType }}</div>
                  <div style="flex-basis: 100%;">{{ item.text }}</div>
                </div>

              </b-card>




              <!-- :disabled="!isFormValid" -->


              <div v-if="!isFormValid" class="text-center"
                style="margin-bottom: 20px;font-size:14px;color: #fb6340;font-weight: bold;">
                Please ensure all required fields are completed.
              </div>

              <div class="text-center" v-if="underwritingMessages.length == 0 && (!((mode == 'view' || mode == 'edit') &&
                model.Customer_policy_status == 'in_progress') ||
                model.Customer_policy_status ==
                'offer_sent_awaiting_information' ||
                model.Customer_policy_status == 'offer_accepted' || quoteModified == true)">
                <b-row align-v="center">
                  <b-col>
                    <base-button data-tour="motor-get-premium" :disabled="!isFormValid || peOnlyVehiclesNeedTowingVehicle || se1VehiclesFleetRequirementNotMet" @click="doQuote()"
                      type="danger" class="mb-4 bg-danger">Get
                      Premium</base-button>
                  </b-col>

                </b-row>
                <!-- <div v-if="model.Customer_policy_status == 'in_progress' ||
              brokerObj.Broker_super_admin
              ">
              <b-row align-v="center" v-if="formMode == 'view'">
                <b-col>
                  <base-button @click="editQuote()" type="danger" class="mb-4 bg-danger">Edit Quote</base-button>
                </b-col>
              </b-row>

              <b-row align-v="center" v-if="formMode == 'edit'">
                <b-col>
                  <base-button @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update Quote</base-button>
                </b-col>
              </b-row>
            </div> -->
              </div>

              <!-- <base-button :disabled="!isFormValid" @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update
              Premium</base-button> -->






              <a ref="calcSection" />
              <b-card no-body class="mb-4" v-if="((mode == 'view' || mode == 'edit') &&
                model.Customer_policy_status == 'in_progress') ||
                model.Customer_policy_status ==
                'offer_sent_awaiting_information' ||
                model.Customer_policy_status == 'offer_accepted'
              ">
                <b-card-header>
                  <h3 class="mb-0">Premium</h3>
                </b-card-header>
                <b-card-body>
                  <b-row>
                    <b-col md="12">
                      <base-input type="read-only-price" disabled prepend-icon="fas fa-dollar-sign"
                        v-model="model.Customer_policy_insurance_total_premium_plus_fees" name="Total Insurance Premium"
                        label="Total Insurance Premium (inc all fees and charges)" />
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium" prepend-icon="fas fa-dollar-sign" readonly
                    name="Insurance Premium" label="Insurance Premium" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_gst" prepend-icon="fas fa-dollar-sign"
                    readonly name="Premium GST" label="Premium GST" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_stamp_duty"
                    prepend-icon="fas fa-dollar-sign" readonly name="Stamp Duty" label="Stamp Duty" />
                </b-col>
                <b-col md="3">
                  <base-input v-model="model.Customer_policy_fee" prepend-icon="fas fa-dollar-sign" readonly
                    name="Policy Fee" label="Policy Fee" />
                </b-col> 
              </b-row> -->
                  <!-- <b-row>
                <b-col md="12">
                  <h5 style="font-size: 11pt !important">Notes:</h5>
                  <div style="margin-bottom: 25px">
                    <ul style="font-size: 11px;margin-bottom: 5px;" v-for="(option, index) in quoteNotes" :key="index">
                      <li style="font-size: 11px;margin-bottom: 5px;">{{ option }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-row> -->
                  <b-row>
                    <b-col md="6">
                      <base-input name="Financier" label="Financier (If known)">
                        <el-select id="financierDD" @change="readFinancier($event)" v-model="model.financier"
                          filterable>
                          <el-option v-for="option in financiers" :key="option.label" :label="option.label"
                            :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col md="6">
                      <base-input id="financierOther" v-bind:disabled="financierOtherDisabled"
                        placeholder="Select 'Other' in dropdown to activate this field" name="Financier - Other"
                        label="Financier - Other" v-model="model.financierOther" />
                    </b-col>
                  </b-row>


                  <b-row>
                    <b-col md="6">
                      <div class="example-btn">
                        <ul>
                          <li v-for="(file, index) in fileList" :key="uploaderKey + '_file_' + index">
                            <div style="display: inline-block">{{ file.name }}</div>
                            <div v-if="!file.success"
                              style="display: inline-block; font-weight: bold; padding-left: 10px">
                              Please wait...file processing
                            </div>
                            <div v-if="file.success"
                              style="display: inline-block; font-weight: bold; padding-left: 10px">
                              Upload successful
                            </div>
                          </li>
                        </ul>
                        <div
                          style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                          Please upload invoice if available
                        </div>
                        <file-upload class="btn btn-primary btn-uploader" :custom-action="customAction"
                          extensions="gif,jpg,jpeg,png,webp,doc,docx,pdf,xls,xlsx,csv"
                          accept="image/png,image/gif,image/jpeg,image/webp,application/msword,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          multiple v-model="fileList" @input-filter="inputFilter" @input-file="inputFile" :input-id="uploaderKey"
                          :ref="uploaderKey" active="true">
                          <i class="fa fa-plus"></i>
                          Select files
                        </file-upload>
                      </div>

                    </b-col>
                  </b-row>

                  <!-- v-if="mode == 'view' &&
                model.Customer_policy_status == 'in_progress'
              " -->

                  <div class="text-center" v-if="mode == 'view' &&
                    model.Customer_policy_status == 'in_progress'
                  ">
                    <b-row style="align-items: end !important;" align-v="center">
                      <b-col>
                        <base-button data-tour="motor-send-to-customer" v-if="sentToCustomer == false" @click="emailOffer('customer')" type="danger"
                          :disabled="isLoading || filesUploading" class="mb-4 bg-danger">Send to Customer</base-button>

                      </b-col>

                      <!-- <b-col v-if="sentToCustomer == false">
                        <b-row style="align-items: end; margin-top: 20px">

                          <b-col>
                            <base-button v-if="sentToBroker == false" @click="emailOffer('broker')" type="danger"
                              class="mb-4 bg-danger">Send to
                              Insurance Broker</base-button>



                          </b-col>
                        </b-row>

                      </b-col> -->
                    </b-row>
                  </div>
                  <!-- <div class="text-center" v-if="model.Customer_policy_status == 'offer_sent_awaiting_information'">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Resend Customer Insurance
                      Offer</base-button>
                  </b-col>
                </b-row>
              </div> -->
                </b-card-body>
              </b-card>
            </form>
          </validation-observer>
        </template>
        <template v-else>
          <b-card class="uBind">
            <h3 class="secondary-card-header">Thank you</h3>
            <div style="margin-bottom: 1.25rem;">
              Thank you. A consent email has been sent{{ quoteOfferSentRecipient }}.
              Once they confirm, the indicative quote will be emailed automatically.
            </div>
            <div class="text-center">
              <base-button type="danger" class="mb-4 bg-danger" @click="goToMotorCreateQuote">
                Create new Quote
              </base-button>
            </div>
          </b-card>
        </template>

      </div>

    </div>


    <b-modal class="modal fade" ref="abn-modal" centered size="lg" scrollable>

      <template v-slot:modal-header>
        <slot name="header">
          <h6 class="modal-title">Search for ABN</h6>
        </slot>
        <slot name="close-button">
          <button type="button" class="close" @click="closeModal" data-dismiss="modal" aria-label="Close">
            <span>×</span>
          </button>
        </slot>
      </template>

      <div style="height: 400px; width: 100%; margin-bottom: 20px;">
        <div style="display: flex; flex-direction: row;">
          <div style="flex-basis: 80%;">
            <input placeholder="eg. ACME PTY LTD" autocomplete="new-password" style="cursor: text" class="form-control"
              id="searchABN" v-model="searchABNstring" />
          </div>
          <div>
            <b-button type="button" variant="danger" class="ml-auto" @click="searchForABNFromModal">Search</b-button>
          </div>
        </div>


        <div
          style="display: flex;flex-direction: row; width: 100%; height: 30px; margin-top: 30px; font-weight: bold; border-bottom: 1px solid lightgray; margin-bottom: 20px;">
          <div style="flex-basis: 40%;">
            Name
          </div>
          <div style="flex-basis: 20%;">
            ABN
          </div>
          <div style="flex-basis: 15%;">
            State
          </div>
          <div style="flex-basis: 15%;">
            Postcode
          </div>
          <div style="flex-basis: 10%;">

          </div>
        </div>

        <div style="display: flex;flex-direction: row; width: 100%; align-items: center; margin-bottom: 10px;"
          v-for="(item, index) in ABNSearchResults" :key="index">
          <div style="flex-basis: 40%;">
            {{ item.organisationName }}
          </div>
          <div style="flex-basis: 20%;">
            {{ item.ABN }}
          </div>
          <div style="flex-basis: 15%;">
            {{ item.state }}
          </div>
          <div style="flex-basis: 15%;">
            {{ item.postCode }}
          </div>
          <div style="flex-basis: 10%;">
            <b-button type="button" variant="danger" class="ml-auto" @click="useABNResult(item)">Use</b-button>
          </div>
        </div>
      </div>



      <template v-slot:modal-footer>
        <div></div>
      </template>

    </b-modal>

    <VehicleModal :showFreightTask="false" :vehicleTypeLabelPrefixes="vehicleTypeLabelPrefixes" ref="vehicleModal"
      :hasTrailerLiability="hasTrailerLiability" @saveVehicle="saveVehicle" />

    <AgreementModal ref="agreementModal" @accepted="onReferralAccepted" />


  </div>



</template>

<script>
import BaseInput from "../components/Inputs/BaseInput.vue";
import { Select, Option, Dropdown } from "element-ui";
import { Modal } from "@/components";
import { dropDowns } from "../assets/data/dropdown_values";
import { quoteFormMethods } from "../helpers/quoteForm";
import { GlobalStore } from "../globalStore";
import { emailMethods } from "../helpers/email";
import { appFunctions } from "../helpers/appFunctions";
import { entsiaFunctions } from "../helpers/entsia";
import Spinner from "../views/dashboard/Spinner.vue";
import ButtonRadioGroup from "../components/ButtonRadioGroup.vue";
import FileUpload from 'vue-upload-component'
import { GlobalMethods } from "../globalMethods";
import axios from "axios";
import { entsiaDropDowns } from "../assets/data/entsiaLOVs";
//import VehicleModal from "./modals/vehicleModal.vue"
import VehicleModal from "../views/motorLive/modals/vehicleModal.vue";
//import { format } from "date-fns";
// import QuotesAndPoliciesVue from "../views/QuotesAndPolicies.vue";
import { parseStringPromise } from 'xml2js';

import { formattingMethods } from "../helpers/formatting";
import { motorQuoteStatus } from "../constants/motorQuoteStatus";
import { getMotorReferralAcceptedSessionKey } from "../helpers/motorReferralAgreement";
import {
  shouldStartMotorQuoteTour,
  startMotorQuoteTour,
  markMotorQuoteTourCompleted
} from "../helpers/motorQuoteTour";
import AgreementModal from "../views/motorLive/modals/agreementModal.vue";

const businessDescriptionVehicleTypeRules = [
  {
    businessDescriptionLabelPrefixes: ["Bus"],
    vehicleTypeLabelPrefixes: ["Bus/Coach"]
  }
];

export default {
  name: "QuoteForm",
  policy_id: "",
  selectedCustomerId: 0,
  props: {
    rawModel: null,
    model: {
      type: Object,
      default: {
        policyStart: "123",
        expiryDate: "456",
        insuredName: "",
        insuredABN: "",
        businessDesc: "",
        contactFName: "",
        contactLName: "",
        contactEmail: "",
        contactPhone: "",
        insuredAddress: "",
        insuredStreet: "",
        insuredCity: "",
        insuredState: null,
        insuredPostcode: "",
        equipmentDescription: "",
        equipmentValue: 0,
        equipmentType: "",
        operatingArea: "",
        usedOnPublicRoad: "",
        insurancePeriod: "12 Months",
        financier: "",
        financierOther: "",
        Customer_policy_insurance_total_premium: null,
        Customer_policy_insurance_total_premium_plus_fees: null,
        Customer_policy_insurance_premium: null,
        Customer_policy_insurance_premium_gst: null,
        Customer_policy_insurance_premium_stamp_duty: null,
        Customer_policy_fee: null,
        Customer_policy_status: null,
        vehicles: [],
      }
    },
    mode: {
      type: String,
      default: "editable"
    }
  },
  data() {
    return {
      entsiaQuoteObject: null,
      selectedItemIndex: null,
      vehicleEditMode: 'add',
      selectedItem: null,
      businessDescriptionsOptions: entsiaDropDowns.businessDescriptionsOptions,
      ABNSearchResults: [],
      searchABNstring: "",
      selectedBrokerEmail: "",
      brokerEmailList: [],
      quoteId: null,
      quoteResponseObject: null,
      quoteModified: false,
      isLoading: false,
      formValid: false,
      formInitData: null,
      selectEquipmentItems: [],
      quoteNotes: [],
      certContents: "",
      realmApp: null,
      formMode: "new",
      financiers: dropDowns.financiers,
      equipmentTypes: dropDowns.protecSureEquipmentTypes,
      states: dropDowns.states,
      operatingAreas: dropDowns.operatingAreas,
      primaryGoodsOptions: entsiaDropDowns.primaryGoodsOptions,
      primaryGoodsOtherOptions: entsiaDropDowns.primaryGoodsOtherOptions,
      usedOnPublicRoadOptions: dropDowns.usedOnPublicRoadOptions,
      numberOfVehiclesOptions: dropDowns.numberOfVehiclesOptions,
      vehicleBrandOptions: dropDowns.vehicleBrandOptions,
      vehicleModelOptions: dropDowns.vehicleModelOptions,
      freightTaskOptions: entsiaDropDowns.freightTaskOptions,
      vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
      currentInsurerOptions: dropDowns.currentInsurerOptions,
      timeInBusinessOptions: entsiaDropDowns.timeInBusinessOptions,
      carModels: entsiaDropDowns.carModels,
      validated: false,
      financierOtherDisabled: true,
      enteredInsuredName: "",
      customerList: [],
      YIHQ_Customer_policy_guid: "",
      fileList: [],
      uploaderKey: 'quoteFileUploader',
      sentToCustomer: false,
      sentToBroker: false,
      hasFormChanges: false,
      referralEmailSent: false,
      apiErrors: [],
      underwritingMessages: [],
      validationMessages: [],
      isMotorQuoteTour: false
    };
  },

  computed: {
    filesUploading() {
      return (this.fileList || []).some((f) => !f.success);
    },
    hasTrailerLiability() {
      return ((this.model && this.model.vehicles) || []).some(
        (v) => v.vehicle && v.vehicle.coverType === "NOTLIA"
      );
    },
    isFormValid() {




      var isValid = true;

      console.log(this.model);

      isValid = this.model.vehicles.length > 0;



      if (this.$refs.formValidator) {

        this.$refs.formValidator.validate();



        //console.log("errors");
        //console.log(this.$refs.formValidator.errors.length)
        //console.log(this.$refs.formValidator);

        // if (this.$refs.formValidator.errors.length > 0) {
        //   isValid = false;
        // }

        //   var customerDetailsValid = await this.$refs.formValidator.validate();
        //   console.log(customerDetailsValid);
        //   if (customerDetailsValid == false) {
        //     isValid = false;
        //   }
      }

      console.log(this.model);

      if (this.model.insuredABN == ""
        || this.model.contactFName == ""
        || this.model.contactLName == ""
        || this.model.contactEmail == ""
        || this.model.contactPhone == ""
        || this.model.insuredCity == ""
        || this.model.businessDesc == ""
        || this.model.insuredState == "") {
        isValid = false;
      }

      console.log(isValid);

      return isValid;
    },

    peOnlyVehiclesNeedTowingVehicle() {
      const opts = this.vehicleTypeOptions || [];
      const vehicleTypeIsPe = (vt) => {
        const o = opts.find((f) => f.value === vt);
        return !!(o && o.PE === true);
      };
      const vehicles = this.model.vehicles || [];
      if (!vehicles.length) return false;
      const hasPeType = vehicles.some((v) => vehicleTypeIsPe(v.vehicle && v.vehicle.vehicleType));
      const hasNonPeType = vehicles.some((v) => !vehicleTypeIsPe(v.vehicle && v.vehicle.vehicleType));
      return hasPeType && !hasNonPeType;
    },

    se1VehiclesFleetRequirementNotMet() {
      const vehicles = this.model.vehicles || [];
      const se1Count = vehicles.filter(
        (v) => v.vehicle && v.vehicle.vehicleType === "SE1"
      ).length;

      if (se1Count === 0) {
        return false;
      }

      const opts = this.vehicleTypeOptions || [];
      const vehicleTypeIsPe = (vt) => {
        const o = opts.find((f) => f.value === vt);
        return !!(o && o.PE === true);
      };

      const hasOtherNonPeVehicle = vehicles.some((v) => {
        const vehicleType = v.vehicle && v.vehicle.vehicleType;
        return vehicleType && vehicleType !== "SE1" && !vehicleTypeIsPe(vehicleType);
      });

      return se1Count < 5 && !hasOtherNonPeVehicle;
    },

    isQuoteOfferSent() {
      return this.sentToCustomer || this.sentToBroker;
    },

    quoteOfferSentRecipient() {
      if (this.sentToCustomer && this.sentToBroker) {
        return " to the customer and to the insurance broker";
      }
      if (this.sentToCustomer) {
        return " to the customer";
      }
      if (this.sentToBroker) {
        return " to the insurance broker";
      }
      return "";
    },

    selectedBusinessDescriptionOption() {
      if (!this.model || !this.model.businessDesc) return null;
      return this.businessDescriptionsOptions.find((option) => option.value === this.model.businessDesc);
    },

    vehicleTypeLabelPrefixes() {
      if (!this.selectedBusinessDescriptionOption) return [];

      const selectedLabel = this.replaceAmp(this.selectedBusinessDescriptionOption.label || "");
      const matchedRule = businessDescriptionVehicleTypeRules.find((rule) => {
        return rule.businessDescriptionLabelPrefixes.some((prefix) => selectedLabel.startsWith(prefix));
      });

      return matchedRule ? matchedRule.vehicleTypeLabelPrefixes : [];
    },

    fieldsDisabled() {
      return quoteFormMethods.getDisabledFields(
        this.formMode,
        this.model.Customer_policy_status
      );
    },
    formRules() {
      return quoteFormMethods.getFormRules("in_progress");
    },
    brokerObj() {
      return GlobalStore.brokerObj;
    }
  },
  methods: {
    markFormDirty() {
      this.hasFormChanges = true;
    },
    async sendReferralNotificationEmail(quoteResp, quoteRecord) {
      const referredReasons = quoteResp &&
        quoteResp.messageData &&
        quoteResp.messageData.policy &&
        quoteResp.messageData.policy.underwritingMessages
        ? quoteResp.messageData.policy.underwritingMessages
        : [];

      if (this.referralEmailSent || referredReasons.length === 0) {
        return;
      }

      const emailModel = {
        ...this.model,
        ...(quoteRecord || {}),
        referredReasons
      };

      try {
        await entsiaFunctions.sendPartnerEmail(emailModel, "live-motor-referred-email", true, false);
        this.referralEmailSent = true;
      } catch (error) {
        console.error("Failed to send motor referral notification email", error);
      }
    },
    hasUnsentCustomerQuote() {
      if (this.sentToCustomer || this.sentToBroker) {
        return false;
      }
      return this.hasFormChanges;
    },
    replaceAmp(ampString) {
      var fixedString = ampString.replace("&amp;", "&");
      return fixedString;
    },
    getAustralianStateFromPostcode(postcode) {
      const parsedPostcode = parseInt(postcode, 10);

      if (isNaN(parsedPostcode)) {
        return "Invalid Postcode";
      }

      // New South Wales (NSW)
      if ((parsedPostcode >= 1000 && parsedPostcode <= 1999) ||
        (parsedPostcode >= 2000 && parsedPostcode <= 2599) ||
        (parsedPostcode >= 2640 && parsedPostcode <= 2899) ||
        (parsedPostcode >= 2921 && parsedPostcode <= 2999)) {
        return 'NSW';
      }
      // Australian Capital Territory (ACT)
      else if ((parsedPostcode >= 200 && parsedPostcode <= 299) ||
        (parsedPostcode >= 2600 && parsedPostcode <= 2639) ||
        (parsedPostcode >= 2900 && parsedPostcode <= 2920)) {
        return 'ACT';
      }
      // Victoria (VIC)
      else if ((parsedPostcode >= 3000 && parsedPostcode <= 3999) ||
        (parsedPostcode >= 8000 && parsedPostcode <= 8999)) {
        return 'VIC';
      }
      // Queensland (QLD)
      else if ((parsedPostcode >= 4000 && parsedPostcode <= 4999) ||
        (parsedPostcode >= 9000 && parsedPostcode <= 9999)) {
        return 'QLD';
      }
      // South Australia (SA)
      else if ((parsedPostcode >= 5000 && parsedPostcode <= 5799) ||
        (parsedPostcode >= 5800 && parsedPostcode <= 5999)) {
        return 'SA';
      }
      // Western Australia (WA)
      else if ((parsedPostcode >= 6000 && parsedPostcode <= 6797) ||
        (parsedPostcode >= 6800 && parsedPostcode <= 6999)) {
        return 'WA';
      }
      // Tasmania (TAS)
      else if (parsedPostcode >= 7000 && parsedPostcode <= 7999) {
        return 'TAS';
      }
      // Northern Territory (NT)
      else if ((parsedPostcode >= 800 && parsedPostcode <= 999) ||
        (parsedPostcode >= 8000 && parsedPostcode <= 8999)) { // Note: NT postcodes also fall into the 8000-8999 range which is shared with VIC for LVRs/PO Boxes. This function prioritizes NT for these ranges.
        return 'NT';
      }

      return 'Unknown State';
    },
    closeVehicleModal() {
      this.$refs['vehicle-modal'].hide();
    },
    editVehicle(_row, idx) {

      this.vehicleEditMode = "edit";

      this.selectedItem = structuredClone(_row);
      this.selectedItemIndex = idx;

      this.$refs['vehicleModal'].openVehicleModal(this.vehicleEditMode, this.selectedItem, this.selectedItemIndex);
    },
    addTrailer(modifiedItem, ownTrailer, trailerSumInsured) {

      //alert("need to add trailer");

      var newTrailer = structuredClone(modifiedItem);

      newTrailer.vehicle.vehicleType = "89";
      newTrailer.vehicle.coverType = "NOTLIA";
      if (ownTrailer == 'YES') {
        //console.log("Own Trailer");
        //console.log(modifiedItem)
        newTrailer.vehicle.sumInsured = parseFloat(trailerSumInsured);
      } else {
        newTrailer.vehicle.sumInsured = 100000;
      }

      newTrailer.vehicle.basicExcess = 2500;

      newTrailer.vehicle.motorwebGlasses.registration = "NA";
      newTrailer.vehicle.motorwebGlasses.vin = "NA";
      //newTrailer.vehicle.vehiclePostcode = "";
      newTrailer.vehicle.motorwebGlasses.make = "NA";
      newTrailer.vehicle.motorwebGlasses.family = "NA";



      console.log(newTrailer);

      // var newItem = {
      //   "vehicle": {
      //     "vehicleLabel": "",
      //     "vehicleLabelPrint": "",
      //     "coverType": "NOTLIA",
      //     "vehicleType": "",
      //     "vehicleClass": "",
      //     "motorwebGlasses": {
      //       "nvic": "",
      //       "registration": "",
      //       "state": "",
      //       "vin": "",
      //       "year": "",
      //       "make": "",
      //       "family": "",
      //       "variant": "",
      //       "style": "",
      //       "transmission": "",
      //       "engine": "",
      //       "resultGlasses": "",
      //       "segment": "",
      //       "newVehicleValue": 0,
      //       "grossMass": "0",
      //       "searchType": "CANT_FIND_MOTORWEB",
      //       "upperMarket": 0,
      //       "vehicleCategory": "PV",
      //       "searchTypeFilter": "BUS"
      //     },
      //     "freightTask": "",
      //     "operatingRadius": "2",
      //     "sumInsuredType": "MARKET",
      //     "sumInsured": 0,
      //     "basicExcess": 500,
      //     "ncb": "50",
      //     "vehiclePostcode": "",
      //     "vehicleState": "",
      //     "dangerousGoodsLimit": "",
      //     "hireVehicle": "NO",
      //     "agreedValueUpper": 0,
      //     "vehicleYear": "",
      //     "isDangerousAndHazardousGoods": "NO",
      //     "isTrailer": "",
      //     "sumInsuredDisplayValue": "",
      //     "ownDamageFilter": "NO",
      //     "isDowntime": "NO",
      //     "isTruck": "NO",
      //     "originalSumInsured": 0,
      //     "vehicleDefaultRadius": "AUSWIDE",
      //     "ncbEditable": "YES",
      //     "vehicleDowntimeRequired": "NO",
      //     "hookLiability": "NO"
      //   }
      // };

      this.model.vehicles.push(newTrailer);
      //this.model = structuredClone(this.model);

    },
    saveVehicle(modifiedItem, ownTrailer, trailerSumInsured) {

      //getAustralianStateFromPostcode

      var state = this.getAustralianStateFromPostcode(modifiedItem.vehicle.vehiclePostcode);

      modifiedItem.vehicle.vehicleState = state;

      if (this.vehicleEditMode == "edit") {
        this.model.vehicles[this.selectedItemIndex] = modifiedItem;
        this.model = structuredClone(this.model);
      } else {



        // || (this.selectedItem.vehicle.vehicleType == '3E' && this.ownTrailer == null)
        // || (this.selectedItem.vehicle.vehicleType == '3E' && this.ownTrailer == 'yes' && this.trailerSumInsured == '')

        const quoteHasTrailerLiability = this.hasTrailerLiability;

        this.model.vehicles.push(structuredClone(modifiedItem));


        console.log("props 2");

        console.log(ownTrailer);
        console.log(trailerSumInsured);


        if (this.selectedItem.vehicle.vehicleType == '3E' && !quoteHasTrailerLiability) {
          this.addTrailer(modifiedItem, ownTrailer, trailerSumInsured);
        }

        this.model = structuredClone(this.model);
      }

      this.quoteChanged();

    },
    addVehicle() {

      this.vehicleEditMode = "add";

      this.selectedItem = {
        "vehicle": {
          "vehicleLabel": "",
          "vehicleLabelPrint": "",
          "coverType": "COMP",
          "vehicleType": "",
          "vehicleClass": "",
          "motorwebGlasses": {
            //"nvic": "",
            "registration": "",
            "state": "",
            "vin": "",
            "year": "",
            "make": "",
            "family": "",
            "variant": "",
            "style": "",
            //"transmission": "",
            //"engine": "",
            //"resultGlasses": "",
            //"segment": "",
            //"newVehicleValue": 0,
            //"grossMass": "0",
            "searchType": "CANT_FIND_GLASSES",
            //"upperMarket": 0,
            //"vehicleCategory": "PV",
            "searchTypeFilter": "NONSEDAN"
          },
          "freightTask": "",
          "operatingRadius": "1",
          "sumInsuredType": "MARKET",
          "sumInsured": 0,
          "basicExcess": 0,
          "ncb": "50",
          "vehiclePostcode": "",
          "vehicleState": "",
          "dangerousGoodsLimit": "",
          "hireVehicle": "NO",
          "agreedValueUpper": 0,
          "vehicleYear": "",
          "isDangerousAndHazardousGoods": "NO",
          "isTrailer": "",
          "sumInsuredDisplayValue": "",
          "ownDamageFilter": "NO",
          "isDowntime": "NO",
          "isTruck": "YES",
          "originalSumInsured": 0,
          "vehicleDefaultRadius": "AUSWIDE",
          "ncbEditable": "YES",
          "vehicleDowntimeRequired": "NO",
          "hookLiability": "NO",
          "noAccessories": "YES",
          "accessories": "",
          "accessoriesSumInsured": ""
        }
      };



      this.$refs['vehicleModal'].openVehicleModal(this.vehicleEditMode, this.selectedItem, 0);
    },
    removeVehicle(idx) {

      this.model.vehicles.splice(idx, 1);

      this.model = structuredClone(this.model);

    },
    async useABNResult(abnObj) {


      var searchQuery = `https://abr.business.gov.au/json/AbnDetails.aspx?abn=` + abnObj.ABN + `&callback=callback&guid=30196ca0-bf23-468b-b7cc-8ea1ad330fb6`;

      const response = await axios.get(
        searchQuery,
        {
          responseType: 'text',
          headers: {
            //Authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
        }
      );

      var cleanedResponse = JSON.parse(response.data.replaceAll("callback(", "").replace("})", "}"));

      var businessStartDate = new Date(cleanedResponse.AbnStatusEffectiveFrom);


      //var firstDate = moment("2013-12-01", 'YYYY-MM-DD'); //Create date using string-format constructor
      //var secondDate = moment("2016-12-01", 'YYYY-MM-DD');
      //var duration = this.$moment.duration((new Date()).diff(businessStartDate));

      var a = this.$moment(new Date());
      var b = this.$moment(businessStartDate);

      var years = a.diff(b, 'year');


      console.log(years);

      this.model.insuredName = abnObj.organisationName;
      this.model.insuredABN = abnObj.ABN;
      this.model.yrsInOperation = years;

      this.model = { ...this.model };

      this.$refs['abn-modal'].hide();


    },
    async searchForABNFromModal() {

      //var businessName = "Code Hive";

      //var searchQuery = `https://abr.business.gov.au/abrxmlsearch/AbrXmlSearch.asmx/ABRSearchByNameAdvancedSimpleProtocol2017?name=` + this.searchABNstring + `&postcode=&legalName=&tradingName=&businessName=&activeABNsOnly=Y&NSW=&SA=&ACT=&VIC=&WA=&NT=&QLD=&TAS=&authenticationGuid=30196ca0-bf23-468b-b7cc-8ea1ad330fb6&searchWidth=&minimumScore=&maxSearchResults=10`;


      var searchQuery = `https://abr.business.gov.au/json/MatchingNames.aspx?name=` + this.searchABNstring + `&callback=callback&guid=30196ca0-bf23-468b-b7cc-8ea1ad330fb6`;

      const response = await axios.get(
        searchQuery,
        {
          responseType: 'text',
          headers: {
            //Authorization: "Bearer " + authToken,
            "Content-Type": "application/json",
          },
        }
      );


      console.log(response.data);



      var cleanedResponse = response.data.replaceAll("callback(", "").replace("})", "}");


      console.log(cleanedResponse);



      var searchResults = [];

      for (var item of JSON.parse(cleanedResponse).Names) {
        searchResults.push({
          organisationName: item.Name,
          score: item.Score,
          state: item.State,
          postCode: item.Postcode,
          ABN: item.Abn,
        });
      }


      this.ABNSearchResults = searchResults;




      /*

      const result = await parseStringPromise(response.data, { explicitArray: false, trim: true });

      //console.log(result);

      var resultList = result.ABRPayloadSearchResults.response.searchResultsList

      console.log(resultList);

      var searchResults = [];

      if (resultList.numberOfRecords > 1) {
        console.log("multiple");
        console.log(result.ABRPayloadSearchResults.response.searchResultsList);
        // searchResults.push({
        // organisationName: resultList.organisationName,
        // score: resultList.score,
        // state: resultList.stateCode,
        // postCode: resultList.postcode,
        // ABN: resultList.identifierValue,
        //});

        for (var item of resultList.searchResultsRecord) {
          console.log(item);
          if (item.businessName) {
            searchResults.push({
              organisationName: item.businessName.organisationName,

              score: item.businessName.score,
              state: item.mainBusinessPhysicalAddress.stateCode,
              postCode: item.mainBusinessPhysicalAddress.postcode,
              ABN: item.ABN.identifierValue,
            });
          }

          if (item.mainName) {
            searchResults.push({
              organisationName: item.mainName.organisationName,
              score: item.mainName.score,
              state: item.mainBusinessPhysicalAddress.stateCode,
              postCode: item.mainBusinessPhysicalAddress.postcode,
              ABN: item.ABN.identifierValue,
            });
          }
        }
      } else {
        if (resultList.numberOfRecords == 1) {
          //console.log("single");
          //console.log(result.ABRPayloadSearchResults.response.searchResultsList);

          searchResults.push({
            organisationName: resultList.searchResultsRecord.mainName.organisationName,
            score: resultList.searchResultsRecord.mainName.score,
            state: resultList.searchResultsRecord.mainBusinessPhysicalAddress.stateCode,
            postCode: resultList.searchResultsRecord.mainBusinessPhysicalAddress.postcode,
            ABN: resultList.searchResultsRecord.ABN.identifierValue,
          });

        }

        console.log(resultList);
      }


      


      //}

      */


      /*
  
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(response.data, "text/xml");
  
      const results = xmlDoc.getElementsByTagName("searchResultsRecord");
  
      var searchResults = [];
  
      for (var item of results) {
  
        searchResults.push({
          organisationName: item.getElementsByTagName("organisationName")[0].innerHTML,
          score: item.getElementsByTagName("score")[0].innerHTML,
          state: item.getElementsByTagName("stateCode")[0].innerHTML,
          postCode: item.getElementsByTagName("postcode")[0].innerHTML,
          ABN: item.getElementsByTagName("identifierValue")[0].innerHTML,
        });
  
      }
  
      this.ABNSearchResults = searchResults;
  
      */

    },
    searchBusiness() {
      this.searchABNstring = this.model.insuredName;

      if (this.model.insuredName != "") {
        this.searchForABNFromModal()
      }

      this.$refs['abn-modal'].show();
    },
    closeModal() {
      this.$refs['abn-modal'].hide();
    },
    copyAddress() {
      this.model.situationStreet = this.model.insuredStreet;
      this.model.situationCity = this.model.insuredCity;
      this.model.situationState = this.model.insuredState;
      this.model.situationPostcode = this.model.insuredPostcode;

      this.model = { ...this.model };
    },
    quoteChanged() {
      this.model.Customer_policy_status = "";
      this.quoteModified = true;
      this.referralEmailSent = false;
    },
    async customAction(file) {
      const blob = await fetch(file.blob).then((res) => res.blob());
      const base64data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      await appFunctions.addFinanceFileAttachment({
        Customer_policy_id: this.YIHQ_Customer_policy_guid,
        fileContent: base64data,
        filename: file.name,
        guid: GlobalMethods.uuidv4(),
        createdDateTime: new Date(),
        type: "ps-equipment-invoice",
      });

      return null;
    },
    /**
     * Has changed
     * @param  Object newFile Read only
     * @param  Object oldFile Read only
     */
    inputFile: function (newFile, oldFile) {

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }

      setTimeout(() => {
        if (
          Boolean(newFile) !== Boolean(oldFile) ||
          oldFile.error !== newFile.error
        ) {
          this.$refs[this.uploaderKey].active = true;
        }
      }, 2000);
    },
    /**
     * Pretreatment
     * @param  Object newFile Read and write
     * @param  Object oldFil  Read only
     * @param  Function prevent Prevent changing
     */
    inputFilter: function (newFile, oldFile, prevent) {
      let pending = (this.fileList || []).some((f) => f !== newFile && !f.success);
      if (newFile && !newFile.success) {
        pending = true;
      }
      this.$emit("disableNextStep", pending);

      if (newFile && !oldFile) {
        // Filter non-image file
        if (
          !/\.(jpeg|jpe|jpg|gif|png|webp|doc|docx|pdf|xls|xlsx|csv)$/i.test(
            newFile.name
          )
        ) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    updateAddressFields(address, street, city, state, postcode) {


      // this.formModel.insuredAddress = metaData.address_line_1;
      // this.formModel.insuredStreet = metaData.address_line_combined;
      // this.formModel.insuredCity = metaData.locality_name;
      // this.formModel.insuredState = metaData.state_territory;
      // this.formModel.insuredPostcode = metaData.postcode;

      this.model.insuredAddress = address;
      this.model.insuredStreet = street;
      this.model.insuredCity = city;
      this.model.insuredState = state;
      this.model.insuredPostcode = postcode;

      this.model = { ...this.model };
    },
    changeModeClicked(evt) {
      console.log(evt);
      //if (evt == "new") {
      this.model.insuredName = "";
      this.model.businessDesc = "";
      this.model.contactEmail = "";
      this.model.contactPhone = "";
      this.model.insuredStreet = "";
      this.model.insuredCity = "";
      this.model.insuredState = "";
      this.model.insuredPostcode = "";
      this.model.insuredABN = "";
      this.model.contactFName = "";
      this.model.contactLName = "";
      this.model.selectedCustomerId = "";
      this.model.Ubind_customer_id = "";

      if (evt == "new") {
        this.setFormDisabled(false)
      }
      else {
        this.setFormDisabled(true)
      }

    },
    setFormDisabled(disabled) {
      this.fieldsDisabled.insuredName = disabled
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled
    },
    // selectCustomer(e) {
    //   console.log(e);
    //   //console.log(this.model.insuredName);
    //   if (e) {
    //     var findCustomer = this.customerList.find(f => f.value == e);
    //     this.enteredInsuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );
    //     this.model.insuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );

    //     console.log(findCustomer);

    //     GlobalStore.realmApp.functions
    //       .crud_customer("get", {
    //         Customer_id: parseInt(e)
    //       })
    //       .then(resp => {
    //         console.log(resp);
    //         var d = resp.data;
    //         this.model.businessDesc = d.Customer_business_description;
    //         this.model.contactEmail = d.Customer_contact_email;
    //         this.model.contactPhone = d.Customer_contact_number;
    //         this.model.insuredStreet = d.Customer_contact_street;
    //         this.model.insuredCity = d.Customer_contact_city;
    //         this.model.insuredState = d.Customer_state;
    //         this.model.insuredPostcode = d.Customer_postcode;
    //         this.model.insuredName = d.Customer_insured_name;
    //         this.model.insuredABN = d.Customer_abn;
    //         this.model.contactFName = d.Customer_contact_first_name;
    //         this.model.contactLName = d.Customer_contact_last_name;

    //         this.fieldsDisabled.businessDesc = true;
    //         this.fieldsDisabled.contactEmail = true;
    //         this.fieldsDisabled.contactPhone = true;
    //         this.fieldsDisabled.insuredStreet = true;
    //         this.fieldsDisabled.insuredCity = true;
    //         this.fieldsDisabled.insuredState = true;
    //         this.fieldsDisabled.insuredPostcode = true;
    //         //this.fieldsDisabled.insuredName = true;
    //         this.fieldsDisabled.insuredABN = true;
    //         this.fieldsDisabled.contactFName = true;
    //         this.fieldsDisabled.contactLName = true;

    //         this.selectedCustomerId = d.Customer_id;
    //       });
    //   }
    //   //   / *\([^)]*\) */g,
    //   //   ""
    //   // );
    // },
    // // InsuredNameBlurred(e) {
    // //   console.log(e);
    // //   this.model.insuredName = this.enteredInsuredName;

    // //   // if (this.model.insuredName.includes("(")) {
    // //   //   this.model.insuredName = this.model.insuredName.replace(
    // //   //     / *\([^)]*\) */g,
    // //   //     ""
    // //   //   );
    // //   // }
    // // },
    // // setInsuredName(e) {
    // //   //console.log(e);
    // //   //this.model.insuredName = e.target.value;

    // //   GlobalStore.realmApp.functions
    // //     .crud_customer("searchCustomerByRealmId", {
    // //       Realm_user_id: GlobalStore.brokerObj.Realm_user_id,
    // //       searchText: e.target.value
    // //     })
    // //     .then(resp => {
    // //       console.log(resp);
    // //       this.customerList = resp.data;
    // //     });

    // //   this.enteredInsuredName = e.target.value;
    // // },
    selectExcess(item, option) {

      this.quoteModified = true;

      item.selectedExcess = item.value;
      item.selectedExcessId = item.id;


      var itemToUpdate = this.selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)
      console.log(itemToUpdate);


      itemToUpdate.selectedExcess = item.value;
      itemToUpdate.selectedExcessId = item.id;


      console.log(item);
      console.log(option);
    },
    toggleEquipmentItem(eqItem) {


      var findEI = this.selectEquipmentItems.find(f => f.categoryItemId == eqItem.categoryItemId);

      if (!findEI) {

        console.log(eqItem);

        var minExcess = 0;
        var minExcessId = 0;

        var excessOptions = this.formInitData.equipmentExcesses.map(m => {
          var enabled = false;

          if (m.excessValue >= eqItem.minimumExcessAllowed) {
            enabled = true;
            minExcess = m.excessValue;
            minExcessId = m.excessId;
          }
          return {
            label: "$" + m.excessValue,
            value: m.excessValue,
            id: m.excessId,
            enabled: enabled,
            selected: false
          }

        });



        this.selectEquipmentItems.push({
          categoryItemId: eqItem.categoryItemId,
          categoryName: eqItem.categoryName,
          excessOptions: excessOptions.filter(f => f.enabled == true),
          selectedExcess: minExcess,
          selectedExcessId: minExcessId,
          //selectedExcess: 0,
          //selectedExcessId: 0,
          insuredAmount: 0
          // {
          //   label: "$100",
          //   value: 100,
          //   enabled: false
          // },
          // {
          //   label: "$250",
          //   value: 250,
          //   enabled: true
          // },
          // {
          //   label: "$500",
          //   value: 500,
          //   enabled: true
          // },
          // {
          //   label: "$1000",
          //   value: 1000,
          //   enabled: true
          // }

        })

        //.map((m) => { return { ...m, ...{ selectedExcess: 0, insuredAmount: 0 } } })


      } else {
        this.selectEquipmentItems = this.selectEquipmentItems.filter(f => f.categoryItemId != eqItem.categoryItemId);
      }



    },
    selectCustomer(e) {
      this.markFormDirty();
      this.selected = true
      const findCustomer = this.customerList.find(f => f.Customer_id == e);
      if (findCustomer && findCustomer.Customer_email_opt_out === true) {
        this.$toasted
          .error(
            "This customer has opted out of emails and cannot be selected.",
            { position: "bottom-center" }
          )
          .goAway(4000);
        this.model.insuredName = "";
        this.formData(null, false);
        return;
      }
      this.enteredInsuredName = findCustomer ? findCustomer.Customer_insured_name : this.enteredInsuredName
      if (findCustomer) {
        this.formData(findCustomer, true)
      } else {
        this.formData(null, false)
      }
    },
    formData(data, disabled) {
      this.model.insuredName = data ? data.Customer_insured_name : this.enteredInsuredName

      var findBusinessDesc = this.businessDescriptionsOptions.find(f => f.value == data.Customer_business_description);
      if (findBusinessDesc) {
        this.model.businessDesc = data ? findBusinessDesc.value : ""
      } else {
        this.model.businessDesc = "";
      }
      this.model.contactEmail = data ? data.Customer_contact_email : ""
      this.model.contactPhone = data ? data.Customer_contact_number : ""


      this.model.insuredStreet = data ? data.Customer_contact_street : ""
      this.model.insuredCity = data ? data.Customer_contact_city : ""
      this.model.insuredState = data ? data.Customer_state : ""
      this.model.insuredPostcode = data ? data.Customer_postcode : ""

      this.model.situationStreet = ""
      this.model.situationCity = ""
      this.model.situationState = ""
      this.model.situationPostcode = ""




      this.model.insuredABN = data ? data.Customer_abn : ""
      this.model.yrsInOperation = ""
      this.model.contactFName = data ? data.Customer_contact_first_name : ""
      this.model.contactLName = data ? data.Customer_contact_last_name : ""
      this.model.selectedCustomerId = data ? data.Customer_id : ""
      this.model.Ubind_customer_id = data ? data.Ubind_customer_id : ""
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled
      this.fieldsDisabled.financier = disabled
    },
    InsuredNameBlurred(e) {
      if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
        this.markFormDirty();
      }
      this.model.insuredName = this.enteredInsuredName;
    },
    setInsuredName(e) {
      this.enteredInsuredName = e.target.value;
      if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
        this.markFormDirty();
      }
    },

    visibleChange(e) {

      console.log("fired");

      if (e) {
        this.selected = false
      }
      if (!e && !this.selected) {
        this.model.insuredName = this.enteredInsuredName;
        if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
          this.markFormDirty();
        }
        this.enteredInsuredName && this.formData(null, false)
      }
    },
    scrollUp() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.topSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#topSection" // required if updateHistory is true
      });
    },
    scrollDown() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.calcSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#calcSection" // required if updateHistory is true
      });
    },
    formatCurrencyString(num) {

      console.log(num);

      return formattingMethods.formatCurrencyStringNoDecimals(num);
    },
    getSumInsuredTypeLabel(sumInsuredType) {
      return sumInsuredType === "MARKET" ? "Market Value" : "";
    },
    goToMotorCreateQuote() {
      // Force a full navigation/reload so the create-quote form resets even when
      // the user is already on /motor-live/createQuote.
      const resolved = this.$router.resolve({
        path: "/motor-live/createQuote",
        query: { _: String(Date.now()) },
      });
      window.location.assign(resolved.href);
    },
    async updateExistingCustomerBusinessDescription() {
      const customerId = this.model.selectedCustomerId || (this.entsiaQuoteObject && this.entsiaQuoteObject.Customer_id);

      if (!customerId) {
        return;
      }

      await appFunctions.crud_customer("updateBusinessDescription", {
        Customer_id: customerId,
        Customer_business_description: this.model.businessDesc
      });
    },
    async createNewQuote() {
      if (this.isMotorQuoteTour) {
        return;
      }

      var totalExcess = this.selectEquipmentItems.reduce((a, b) => a + b.selectedExcess, 0);

      this.quoteModified = false;

      // add(1, 'days')

      var currentDate = this.$moment(new Date()).format(
        "YYYY-MM-DD"
      );

      this.model.situationStreet = this.model.insuredStreet;
      this.model.situationCity = this.model.insuredCity;
      this.model.situationState = this.model.insuredState;
      this.model.situationPostcode = this.model.insuredPostcode;

      //this.model.vehicles[0].vehicle.sumInsured = parseFloat(this.model.vehicles[0].vehicle.sumInsured);

      for (var vehicle of this.model.vehicles) {
        vehicle.vehicle.sumInsured = parseFloat(vehicle.vehicle.sumInsured);
        vehicle.vehicle.basicExcess = parseFloat(vehicle.vehicle.basicExcess);

        vehicle.vehicle.makeListNotFound = "YES";
        vehicle.vehicle.manualMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.manualMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.makeListNotFound = "YES";
        //vehicle.vehicle.vehicleMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.makeList = vehicle.vehicle.motorwebGlasses.make;

        if (vehicle.vehicle.vehicleType == 'SE1') {
          vehicle.vehicle.sumInsuredType = "AGREED";
          vehicle.vehicle.motorwebGlasses = {
            //"reference": "bc295610-3a11-4c2c-8aea-b8e5d85c18e6",
            "registration": vehicle.vehicle.motorwebGlasses.registration,
            "state": vehicle.vehicle.motorwebGlasses.state,
            "vin": vehicle.vehicle.motorwebGlasses.vin,
            "year": vehicle.vehicle.motorwebGlasses.year,
            "make": vehicle.vehicle.motorwebGlasses.make,
            "family": vehicle.vehicle.motorwebGlasses.family,
            "variant": vehicle.vehicle.motorwebGlasses.variant || "",
            "style": vehicle.vehicle.motorwebGlasses.style || "",
            "searchType": "CANT_FIND_GLASSES_SEDAN",
            "vehicleCategory": "PV",
            "searchTypeFilter": "SEDAN"
          }
        }
      }


      // this.model.vehicles = this.model.vehicles.map(m => {
      //   return { ...m, ...{ vehicle: { sumInsured: parseFloat(m.vehicle.sumInsured) }} }
      // }
      // )

      let entsiaAccountNumber = "CT000000";
      try {
        const cfg = await appFunctions.getConfig();
        if (cfg && cfg.entsiaInfo && cfg.entsiaInfo.accountNumber) {
          entsiaAccountNumber = cfg.entsiaInfo.accountNumber;
        }
      } catch (e) {
        console.warn("getConfig failed for entsia accountNumber", e);
      }

      var quoteToSend = {
        "externalOpportunityId": "1234",
        "externalMessageId": GlobalMethods.uuidv4(),
        "correlationId": GlobalMethods.uuidv4(),
        "externalProductCode": "345345345",
        "callBackUrl": "",
        "messageData": {
          "policy": {
            "productReference": "TRANSPORTATION_PRODUCT",
            "policyWordingReference": "TRANSPORT_PACKAGE",
            "termStartDate": currentDate,
            "accountNumber": entsiaAccountNumber,
            "insured": {
              "insuredRoot": {
                "insuredType": "COMPANY",
                "registeredForGst": "YES",
                //"abnSearch": this.model.insuredABN,
                //"abnSearchFilter": this.model.insuredABN,
                "abn": this.model.insuredABN,
                "insuredName": this.model.insuredName,
                "tmdConsidered": "YES",
                //"insuredNameSummary": "John Insured"
              }
            },
            "sharedPolicySubproduct": {
              "sharedPolicyDetails": {
                "underwriterAgencyFeeOverrideFlag": "NO",
                "liabilitySectionTaken": "NO",
                "carriersSectionTaken": "NO",
                "downtimeSectionTaken": "NO",
                "motorSectionTaken": "YES",
                "transportCoverType": {
                  "propertyRef": "TRANSPORT_COVER_TYPE",
                  "selectedValues": [
                    {
                      "code": "CM"
                    }
                  ]
                }
              },
              "intermediaryDetails": {
                "intermediaryContact": GlobalStore.brokerObj.Broker_first_name + " " + GlobalStore.brokerObj.Broker_last_name,
                "intermediaryEmail": GlobalStore.brokerObj.Broker_email,
                "intermediaryPhone": GlobalStore.brokerObj.Broker_phone,
                "branchCode": "ALL"
              },
              "disclosureDetails": {
                "priorClaims": "NO",
                "claimDenied": "NO",
                "bankruptcy": "NO",
                "criminalConviction": "NO",
                "thermalCoalMines": "NO"
              }
            },
            "sharedLiabilitySubproduct": {
              "generalBusinessDetails": {
                "businessDescription": this.model.businessDesc,
                "addressOfPrincipalSituation": {
                  "addressLine1": this.model.situationStreet,
                  "suburb": this.model.situationCity,
                  "state": this.model.situationState,
                  "postcode": this.model.situationPostcode,
                }
              }
            },
            "commercialMotorSubproduct": {
              "generalMotorDetails": {
                "motorRiskRequired": "YES",
                "principalAddress": {
                  "addressLine1": this.model.insuredStreet,
                  "suburb": this.model.insuredCity,
                  "state": this.model.insuredState,
                  "postcode": this.model.insuredPostcode,
                  "addressSearch": this.model.insuredStreet + " " + this.model.insuredCity + " " + this.model.insuredState + " " + this.model.insuredPostcode
                },
                "policyCode": "BUS",
                "radiusOfOperation": "1",
                "occupationCode": this.model.businessDesc,
                "yearsOfOperation": this.model.lengthOfOperating,
                "policyDownTimeRequired": "NO",
                "powerUnit": 0,
                "nswSdExemption": "NO",
                "inelligibleRiskComposition": "NO"
              },
              "motorDisclosure": {
                "licenceSuspension": "NO",
                "convictedAlcoholDrug": "NO",
                "atFault": "NO",
                "claimLodged": "NO",
                "primeDriverUnderExperience": "NO",
                "rigidDriverUnderExperience": "NO"
              },
              "vehiclesAndGoods": {
                "primaryGood": "GC",
                "currentlyInsured": "NO",

                "uninsuredReason": "1",
                //"previousInsurer": "INS00061",
                "vehicleUsageOffRoad": "NO",
                "vehicleUsageSpecialFitOut": "NO",
                "vehicleUsagePassengerHired": "NO",
                "listOfVehicles": this.model.vehicles,
                "hasBus": "NO",
                "hasTruck": "NO",
                "hasTrailer": "NO"
              },
              "dangerousGoodsDisclosure": {
                "bulkDangerousGoodsCarried": "NO",
                "listOfDangerousGoods": [
                  {}
                ]
              },
              "motorPremiumDetails": {
                "nonFinancialCover": "NO"
              }
            }
          }
        }
      };




      let internalCustId = this.model.selectedCustomerId;

      if (!this.model.selectedCustomerId) {
        var newCustomer = {
          Customer_insured_name: this.model.insuredName,
          Customer_abn: this.model.insuredABN,
          Customer_contact_first_name: this.model.contactFName,
          Customer_contact_last_name: this.model.contactLName,
          Customer_contact_email: this.model.contactEmail,
          Customer_contact_number: this.model.contactPhone,
          Customer_contact_street: this.model.insuredStreet,
          Customer_contact_city: this.model.insuredCity,
          Customer_state: this.model.insuredState,
          Customer_postcode: this.model.insuredPostcode,
          Customer_country: "",
          Customer_business_description: this.model.businessDesc,
          Broker_org_id: GlobalStore.brokerObj.parentOrg.Broker_org_id,
          Broker_id: GlobalStore.brokerObj.Broker_id,
          Insurance_broker_id:
            GlobalStore.brokerObj.parentOrg.parentInsuranceBroker
              .insurance_broker_id
        };

        const customerResp = await appFunctions.crud_customer(
          "create",
          newCustomer
        );

        if (!customerResp.data.Customer_id) {
          toasts.error(
            "Uh ohh... could not create " +
            formModel.insuredName +
            " please try again."
          );
          return;
        }

        internalCustId = customerResp.data.Customer_id;
      } else {
        await this.updateExistingCustomerBusinessDescription();
      }



      // var quoteToSend = {
      //   "brokerId": GlobalStore.brokerObj.Broker_id,
      //   "type": "light-machinery",
      //   "inceptionDate": this.model.policyStart,
      //   "expiryDate": this.model.expiryDate,
      //   "periodOfCover": 12,
      //   "insuredPostcode": this.model.insuredPostcode,
      //   "insuredState": this.model.insuredState,
      //   "insuredSuburb": this.model.insuredCity,
      //   "insuredName": this.model.insuredName,
      //   "excess": totalExcess,
      //   "registeredForGst": this.model.registeredForGST,
      //   "source": "YIHQ Form",
      //   "equipmentItems": this.selectEquipmentItems.map(m => {
      //     return {
      //       "itemId": m.categoryItemId,
      //       "specifiedSumInsured": parseFloat(m.insuredAmount),
      //       "unSpecifiedSumInsured": 0,
      //       "excessId": m.selectedExcessId
      //     }
      //   }),
      //   "customFields": {
      //     "customerId": internalCustId,
      //     "claimsOrLossesLast3Years": false,
      //     "moreThan50k": false,
      //     "isChubbCurrentlyUnderWriting": false
      //   }
      // }

      //var quoteToSend = {};



      console.log(quoteToSend);
      //console.log(totalExcess);
      //console.log(this.selectEquipmentItems);

      this.model.Customer_policy_status = "";


      //this.mode = "view";
      //this.model.Customer_policy_status = "in_progress";

      var brokerFee = 0;

      console.log(brokerFee);


      this.isLoading = true;

      var brokerFees = 0;

      //console.log()



      console.log(quoteToSend);

      //let internalCustId = this.model.selectedCustomerId;

      var yihqData = {
        "quoteId": this.quoteId,
        "brokerId": GlobalStore.brokerObj.Broker_id,
        //"type": "motor-live",
        //"inceptionDate": this.model.policyStart,
        //"expiryDate": this.model.expiryDate,
        //"periodOfCover": 12,
        //"insuredPostcode": this.model.insuredPostcode,
        //"insuredState": this.model.insuredState,
        //"insuredSuburb": this.model.insuredCity,
        //"insuredName": this.model.insuredName,
        //"excess": totalExcess,
        //"registeredForGst": this.model.registeredForGST,
        //"source": "YIHQ Form",
        // "equipmentItems": this.selectEquipmentItems.map(m => {
        //   return {
        //     "itemId": m.categoryItemId,
        //     "specifiedSumInsured": parseFloat(m.insuredAmount),
        //     "unSpecifiedSumInsured": 0,
        //     "excessId": m.selectedExcessId
        //   }
        // }),
        "customFields": {
          "customerId": internalCustId,
          //"claimsOrLossesLast3Years": false,
          //"moreThan50k": false,
          //"isChubbCurrentlyUnderWriting": false
        }
      }



      entsiaFunctions.requestQuote({ yihqData, quoteRequestData: quoteToSend }).then(async (resp) => {
        console.log(resp);

        var validResponse = true;

        this.isLoading = false;


        if (resp.quoteResp.response && resp.quoteResp.response.errors && resp.quoteResp.response.errors.length > 0) {
          this.apiErrors = resp.quoteResp.response.errors;
          validResponse = false;
          //alert("error");
        } else {

          this.apiErrors = [];

          if (resp.quoteResp.messageData.policy.underwritingMessages) {
            this.underwritingMessages = resp.quoteResp.messageData.policy.underwritingMessages;
            validResponse = false;
            this.hasbeenReferred = true;
            await this.sendReferralNotificationEmail(resp.quoteResp, resp.insertedQuote);
          } else {
            this.underwritingMessages = [];

          }

          if (resp.quoteResp.messageData.policy.validationMessages && resp.quoteResp.messageData.policy.validationMessages.filter(f => f.messageType != "INFORMATION").length > 0) {
            this.validationMessages = resp.quoteResp.messageData.policy.validationMessages;
            validResponse = false;
          } else {
            this.validationMessages = [];
          }

          console.log(this.underwritingMessages);



        }

        if (validResponse == true) {

          this.mode = "view";

          //var premium = resp.messageData.policy.premiums[0].premium.premiumItem.total.value;

          var premium = resp.quoteResp.totalPremiumIncFees;

          this.model.Customer_policy_insurance_total_premium_plus_fees = premium;

          this.quoteId = resp.quoteResp.YIHQ_Customer_policy_guid;

          this.quoteResponseObject = resp.quoteResp;

          this.model.Customer_policy_status = "in_progress";

          this.YIHQ_Customer_policy_guid = resp.quoteResp.YIHQ_Customer_policy_guid;

          this.entsiaQuoteObject = resp.insertedQuote;

          this.scrollDown();
        }


      

        this.model.Customer_policy_status = "in_progress";

        this.scrollDown();

        //this.model = {...this.model};

        this.isLoading = false;
      })


    },
    async updateQuote() {
      if (this.isMotorQuoteTour) {
        return;
      }

      console.log(this.entsiaQuoteObject);
      await this.updateExistingCustomerBusinessDescription();




      //var currentDate = this.$moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
      //var endDate = this.$moment(new Date()).add(1, 'years').format("YYYY-MM-DD");

      //this.model.Data_obj.messageData.policy.inceptionDate = currentDate;

      //this.model.Data_obj.messageData.policy.termStartDate = currentDate;
      //this.model.Data_obj.messageData.policy.termEndDate = endDate;


      //this.model.Data_obj.messageData.policy.effectiveDate = currentDate;

      //"termStartDate": currentDate,

      //this.model = this.modifyNCB(this.model);



      // var modelToSend = structuredClone(this.model);

      // for (var vehicle of this.entsiaQuoteObject.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.listOfVehicles) {
      //   vehicle.vehicle.sumInsured = parseFloat(vehicle.vehicle.sumInsured);
      //   vehicle.vehicle.basicExcess = parseFloat(vehicle.vehicle.basicExcess);
      // }

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.primaryGood = this.model.primaryGoods;
      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.currentlyInsured = this.model.currentlyInsured == true ? "YES" : "NO";


      // if (this.model.currentlyInsured == false) {
      //   //modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason = this.model.reasonsNotInsured || "";
      //   modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason = this.model.reasonNotInsured || "1";
      //   delete modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.previousInsurer;
      // }

      // if (this.model.currentlyInsured == true) {
      //   delete modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason
      //   modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.previousInsurer = this.model.currentInsurer;
      // }

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.nswSdExemption = this.model.nswSdExemption == true ? "YES" : "NO";

      // if (this.model.nswSdExemption == true) {
      //   modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.nswSdExemptionDeclaration = "YES";
      // }

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.yearsOfOperation = this.model.lengthOfOperating;

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.radiusOfOperation = this.model.radiusOfOperation;

      // console.log(modelToSend);

      // modelToSend.Data_obj.messageData.policy.sharedPolicySubproduct.disclosureDetails.listOfClaims = this.model.listOfClaims;


      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.atFault = this.model.atFault ? "YES" : "NO";

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.claimLodged = this.model.claimLodged ? "YES" : "NO";

      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.dangerousGoodsDisclosure.bulkDangerousGoodsCarried = this.model.dangerousGoods1 ? "YES" : "NO";


      // modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.dangerousGoodsDisclosure.listOfDangerousGoods = this.model.listOfDangerousGoods;




      // console.log(modelToSend);

      this.model.Customer_policy_status = "";


      this.isLoading = true;
      // this.hasbeenReferred = false;


      // var yihqData = {
      //   "quoteId": modelToSend.quoteId,
      //   "brokerId": modelToSend.Broker_id,
      //   "customFields": {
      //     "customerId": modelToSend.Customer_id,
      //   }
      // }

      for (var vehicle of this.model.vehicles) {
        vehicle.vehicle.sumInsured = parseFloat(vehicle.vehicle.sumInsured);
        vehicle.vehicle.basicExcess = parseFloat(vehicle.vehicle.basicExcess);

        vehicle.vehicle.makeListNotFound = "YES";
        vehicle.vehicle.manualMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.manualMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.makeListNotFound = "YES";
        //vehicle.vehicle.vehicleMake = vehicle.vehicle.motorwebGlasses.make;
        //vehicle.vehicle.motorwebGlasses.makeList = vehicle.vehicle.motorwebGlasses.make;

        if (vehicle.vehicle.vehicleType == 'SE1') {
          vehicle.vehicle.sumInsuredType = "AGREED";
          vehicle.vehicle.motorwebGlasses = {
            //"reference": "bc295610-3a11-4c2c-8aea-b8e5d85c18e6",
            "registration": vehicle.vehicle.motorwebGlasses.registration,
            "state": vehicle.vehicle.motorwebGlasses.state,
            "vin": vehicle.vehicle.motorwebGlasses.vin,
            "year": vehicle.vehicle.motorwebGlasses.year,
            "make": vehicle.vehicle.motorwebGlasses.make,
            "family": vehicle.vehicle.motorwebGlasses.family,
            "variant": vehicle.vehicle.motorwebGlasses.variant || "",
            "style": vehicle.vehicle.motorwebGlasses.style || "",
            "searchType": "CANT_FIND_GLASSES_SEDAN",
            "vehicleCategory": "PV",
            "searchTypeFilter": "SEDAN"
          }
        }
      }


      this.entsiaQuoteObject.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.listOfVehicles = this.model.vehicles;

console.log(this.model.businessDesc);

      this.entsiaQuoteObject.Data_obj.messageData.policy.sharedLiabilitySubproduct.generalBusinessDetails.businessDescription =this.model.businessDesc;
           

      this.entsiaQuoteObject.Data_obj.messageData.policy.status = "DRAFT";

      var resp = await entsiaFunctions.updateQuote(this.entsiaQuoteObject);



      console.log("here");
      console.log(resp);



      var validResponse = true;

      this.isLoading = false;


      if (resp.quoteResp.response && resp.quoteResp.response.errors && resp.quoteResp.response.errors.length > 0) {
        this.apiErrors = resp.quoteResp.response.errors;
        validResponse = false;
        //alert("error");
      } else {

        this.apiErrors = [];

        if (resp.quoteResp.messageData.policy.underwritingMessages) {
          this.underwritingMessages = resp.quoteResp.messageData.policy.underwritingMessages;
          validResponse = false;
          this.hasbeenReferred = true;
          await this.sendReferralNotificationEmail(resp.quoteResp, resp.updatedQuote || this.entsiaQuoteObject);
        } else {
          this.underwritingMessages = [];

        }

        if (resp.quoteResp.messageData.policy.validationMessages) {
          this.validationMessages = resp.quoteResp.messageData.policy.validationMessages;
          validResponse = false;
        } else {
          this.validationMessages = [];
        }

      }

      // if (this.model.listOfClaims.length == 0 && (modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.atFault == "YES" || modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.claimLodged == "YES")) {
      //   this.$refs["pastClaimsList"].addClaim();
      // }



      if (validResponse == true) {

        //this.model.Data_obj = resp;

        //console.log(resp);

        //this.model.Data_obj.totalPremiumIncFees = resp.totalPremiumIncFees;

        this.quoteModified = false;

        this.mode = "view";

        var premium = resp.quoteResp.totalPremiumIncFees;

        this.model.Customer_policy_insurance_total_premium_plus_fees = premium;

        //this.quoteId = resp.quoteResp.YIHQ_Customer_policy_guid;

        this.quoteResponseObject = resp.quoteResp;

        this.model.Customer_policy_status = "in_progress";

        //this.YIHQ_Customer_policy_guid = resp.quoteResp.YIHQ_Customer_policy_guid;

        this.entsiaQuoteObject = resp.updatedQuote;

        this.scrollDown();


      }





    },
    async updateQuoteOld() {

      var totalExcess = this.selectEquipmentItems.reduce((a, b) => a + b.selectedExcess, 0);

      let internalCustId = this.model.selectedCustomerId;
      /*
      if (!this.model.selectedCustomerId) {
        var newCustomer = {
          Customer_insured_name: this.model.insuredName,
          Customer_abn: this.model.insuredABN,
          Customer_contact_first_name: this.model.contactFName,
          Customer_contact_last_name: this.model.contactLName,
          Customer_contact_email: this.model.contactEmail,
          Customer_contact_number: this.model.contactPhone,
          Customer_contact_street: this.model.insuredStreet,
          Customer_contact_city: this.model.insuredCity,
          Customer_state: this.model.insuredState,
          Customer_postcode: this.model.insuredPostcode,
          Customer_country: "",
          Customer_business_description: this.model.businessDesc,
          Broker_org_id: GlobalStore.brokerObj.parentOrg.Broker_org_id,
          Broker_id: GlobalStore.brokerObj.Broker_id,
          Insurance_broker_id:
            GlobalStore.brokerObj.parentOrg.parentInsuranceBroker
              .insurance_broker_id
        };
  
        const customerResp = await appFunctions.crud_customer(
          "create",
          newCustomer
        );
  
        if (!customerResp.data.Customer_id) {
          toasts.error(
            "Uh ohh... could not create " +
            formModel.insuredName +
            " please try again."
          );
          return;
        }
  
        internalCustId = customerResp.data.Customer_id;
      }
        */

      var quoteToSend = {
        "quoteId": this.quoteId,
        "brokerId": GlobalStore.brokerObj.Broker_id,
        "type": "light-machinery",
        "inceptionDate": this.model.policyStart,
        "expiryDate": this.model.expiryDate,
        "periodOfCover": 12,
        "insuredPostcode": this.model.insuredPostcode,
        "insuredState": this.model.insuredState,
        "insuredSuburb": this.model.insuredCity,
        "insuredName": this.model.insuredName,
        "excess": totalExcess,
        "registeredForGst": this.model.registeredForGST,
        "source": "YIHQ Form",
        "equipmentItems": this.selectEquipmentItems.map(m => {
          return {
            "itemId": m.categoryItemId,
            "specifiedSumInsured": parseFloat(m.insuredAmount),
            "unSpecifiedSumInsured": 0,
            "excessId": m.selectedExcessId
          }
        }),
        "customFields": {
          "customerId": internalCustId,
          "claimsOrLossesLast3Years": false,
          "moreThan50k": false,
          "isChubbCurrentlyUnderWriting": false
        }
      }


      console.log(quoteToSend);
      //console.log(totalExcess);
      //console.log(this.selectEquipmentItems);




      //this.mode = "view";
      //this.model.Customer_policy_status = "in_progress";

      var brokerFee =

        console.log(brokerFee);


      this.isLoading = true;

      var brokerFees = 0;

      //console.log()





      // protecsureFunctions.updateQuote(quoteToSend).then(async (resp) => {
      //   console.log(resp);





      //   this.mode = "view";


      //   this.model.Customer_policy_insurance_total_premium =
      //     resp.totalPremium;

      //   //var brokerFee = await this.calculateBrokerFee(resp.totalPremium);

      //   this.model.Customer_policy_insurance_total_premium_plus_fees = resp.totalPremiumIncFees;
      //   this.model.Customer_policy_insurance_premium =
      //     resp.grossBasePremium;
      //   this.model.Customer_policy_insurance_premium_gst =
      //     resp.gst;
      //   this.model.Customer_policy_insurance_premium_stamp_duty =
      //     resp.stampDuty;
      //   //this.model.Customer_policy_fee = calcData.Customer_policy_fee;

      //   resp.equipmentExcesses.forEach(item => {
      //     this.quoteNotes.push(item.description)
      //   })

      //   resp.equipmentMaxLiability.forEach(item => {
      //     this.quoteNotes.push(item.description)
      //   })

      //   this.YIHQ_Customer_policy_guid = resp.YIHQ_Customer_policy_guid;


      //   this.isLoading = false;



      //   this.model.Customer_policy_status = "in_progress";

      //   this.scrollDown();


      // })


    },
    async doQuote() {
      if (this.isMotorQuoteTour) {
        return;
      }
      if (this.quoteId == null) {
        this.createNewQuote();
      } else {
        this.updateQuote();
      }
    },
    async emailOffer(_type) {
      if (this.isMotorQuoteTour) {
        return;
      }
      // quoteFormMethods.changeStatus(
      //   this.policy_id,
      //   "offer_sent_awaiting_information"
      // );

      // GlobalStore.realmApp.functions
      //   .crud_customerPolicy("getCombined", {
      //     policy_id: parseInt(this.policy_id)
      //   })
      //   .then(resp => {
      //emailMethods.sendOfferEmail(GlobalStore.realmApp, resp.data);
      //     this.$router.push("/quotes/" + this.policy_id + "/offerSent");
      //   });

      // emailMethods.sendPSContinueQuoteEmail(
      //   GlobalStore.realmApp,
      //   //resp.data,
      //   //"VIBS",
      //   //"YIHQ-PSLIVE"
      // );

      this.isLoading = true;
      try {
        if (_type == "customer") {
          await appFunctions.crud_customerPolicy("updateMotorQuoteByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
            financier: this.model.financier,
            financierOther: this.model.financierOther,
            status: motorQuoteStatus.consentEmailSent,
          });

          const resp = await appFunctions.crud_customerPolicy("getCombinedByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
            financier: this.model.financier,
            financierOther: this.model.financierOther,
          });

          await emailMethods.sendMLConsentToContinueQuoteEmail(
            GlobalStore.realmApp,
            resp.data
          );

          this.sentToCustomer = true;
        } else {
          await appFunctions.crud_customerPolicy("updateMotorQuoteByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
            financier: this.model.financier,
            financierOther: this.model.financierOther,
            status: motorQuoteStatus.sentToBroker,
          });

          const resp = await appFunctions.crud_customerPolicy("getCombinedByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
          });

          await emailMethods.sendMotorContinueQuoteEmailToBroker(
            GlobalStore.realmApp,
            resp.data,
            this.selectedBrokerEmail
            //"VIBS",
            //this.$route.params.productName
          );

          this.sentToBroker = true;
        }
      } catch (error) {
        console.error(error);
        toasts.error("Could not send quote email. Please try again.");
      } finally {
        this.isLoading = false;
      }
    },
    editQuote() {
      this.formMode = "edit";
      this.scrollUp();
    },
    async changeInceptionDate(evt) {
      //console.log(evt.target.value);


      //console.log(this.$moment(new Date(evt.target.value)).add(1,'y').format('YYYY-MM-DD'));

      this.model.expiryDate = this.$moment(new Date(evt.target.value)).add(1, 'y').format('YYYY-MM-DD')

      // protecsureFunctions.getUpdatedPeriodOfCover(evt.target.value).then(resp => {
      //   this.expiryDate = resp.periodOfCover.expiryDate 

      // });
    },
    // updateQuote() {
    //   var calcData = quoteFormMethods.getCalculation(this.model);

    //   this.model.Customer_policy_insurance_total_premium =
    //     calcData.Customer_policy_insurance_total_premium;
    //   this.model.Customer_policy_insurance_premium =
    //     calcData.Customer_policy_insurance_premium;
    //   this.model.Customer_policy_insurance_premium_gst =
    //     calcData.Customer_policy_insurance_premium_gst;
    //   this.model.Customer_policy_insurance_premium_stamp_duty =
    //     calcData.Customer_policy_insurance_premium_stamp_duty;
    //   this.model.Customer_policy_fee = calcData.Customer_policy_fee;

    //   quoteFormMethods.updateQuote(this.realmApp, this.rawModel, this.model);

    //   this.scrollDown();

    //   this.formMode = "view";
    // },
    firstFormSubmit() {
      console.log("clicked");
    },
    readBrokerEmail(event) {

    },
    readFinancier(event) {
      console.log("typed");
      if (event == "Other") {
        this.financierOtherDisabled = false;
        //this.model.financier = "";
      } else {
        this.financierOtherDisabled = true;
        this.model.financierOther = "";
      }
    },
    /**
     * @desc Clears the address city, state and postcode fields when the street
     * field is cleared.
     */
    clearAddressFields() {
      if (this.model.insuredStreet == "") {
        this.model.insuredCity = "";
        this.model.insuredState = "";
        this.model.insuredPostcode = "";
      }
    },
    maybeStartMotorQuoteTour() {
      if (!shouldStartMotorQuoteTour()) {
        return;
      }
      this.$nextTick(() => {
        startMotorQuoteTour(this);
      });
    },
    onReferralAccepted() {
      this.$nextTick(() => {
        setTimeout(() => this.maybeStartMotorQuoteTour(), 350);
      });
    },
    applyTourDummyCustomerType() {
      this.formMode = "new";
    },
    applyTourDummyBusiness() {
      this.model.insuredName = "Demo Transport Pty Ltd";
      this.model.insuredABN = "51824753556";
      this.model.businessDesc = "AGRICF";
      this.quoteChanged();
    },
    applyTourDummyContact() {
      this.model.contactFName = "Alex";
      this.model.contactLName = "Demo";
      this.model.contactPhone = "0400000000";
      this.model.contactEmail = "demo.customer@example.com";
      this.model.insuredStreet = "1 Example Street";
      this.model.insuredCity = "Brisbane";
      this.model.insuredState = "QLD";
      this.model.insuredPostcode = "4000";
      this.quoteChanged();
    },
    applyTourDummyVehicle() {
      const modal = this.$refs.vehicleModal;
      if (!modal || !modal.selectedItem || !modal.selectedItem.vehicle) {
        return;
      }
      const vehicle = modal.selectedItem.vehicle;
      vehicle.vehicleType = "3C";
      vehicle.motorwebGlasses.registration = "DEMO123";
      vehicle.motorwebGlasses.make = "Hino";
      vehicle.motorwebGlasses.family = "500";
      vehicle.motorwebGlasses.year = "2020";
      vehicle.motorwebGlasses.vehicleYear = "2020";
      vehicle.vehicleYear = "2020";
      vehicle.vehiclePostcode = "4000";
      vehicle.sumInsured = 50000;
      vehicle.basicExcess = 500;
      vehicle.ncb = "50";
      modal.vehicleTypeChanged();
      modal.saveVehicle();
    },
    applyTourMockPremium() {
      this.mode = "view";
      this.model.Customer_policy_insurance_total_premium_plus_fees = 1234.56;
      this.model.Customer_policy_status = "in_progress";
      this.sentToCustomer = false;
    },
    resetMotorQuoteTourForm() {
      if (this.$refs.vehicleModal && this.$refs.vehicleModal.closeVehicleModal) {
        this.$refs.vehicleModal.closeVehicleModal();
      }
      this.formMode = "new";
      this.mode = "editable";
      this.sentToCustomer = false;
      this.sentToBroker = false;
      this.quoteId = null;
      this.quoteResponseObject = null;
      this.entsiaQuoteObject = null;
      this.YIHQ_Customer_policy_guid = "";
      this.quoteModified = false;
      this.underwritingMessages = [];
      this.validationMessages = [];
      this.model.insuredName = "";
      this.model.insuredABN = "";
      this.model.businessDesc = "";
      this.model.contactFName = "";
      this.model.contactLName = "";
      this.model.contactEmail = "";
      this.model.contactPhone = "";
      this.model.insuredStreet = "";
      this.model.insuredCity = "";
      this.model.insuredState = null;
      this.model.insuredPostcode = "";
      this.model.vehicles = [];
      this.model.Customer_policy_status = null;
      this.model.Customer_policy_insurance_total_premium_plus_fees = null;
      this.model.Customer_policy_insurance_total_premium = null;
      this.model.Customer_policy_insurance_premium = null;
      this.model.Customer_policy_insurance_premium_gst = null;
      this.model.Customer_policy_insurance_premium_stamp_duty = null;
      this.model.Customer_policy_fee = null;
    },
    async finishMotorQuoteTour() {
      await markMotorQuoteTourCompleted();
      this.resetMotorQuoteTourForm();
      this.isMotorQuoteTour = false;
      this._motorQuoteTourDriver = null;
    }
  },

  async mounted() {

    this.isLoading = false;

    //this.$refs['abn-modal'].show();


    const brokerSessionKey = getMotorReferralAcceptedSessionKey();
    if (!sessionStorage.getItem(brokerSessionKey)) {
      this.$refs["agreementModal"].openModal();
    } else {
      this.maybeStartMotorQuoteTour();
    }



    await appFunctions.crud_brokerOrg("getBrokerList", {
      Broker_org_id: GlobalStore.brokerObj.Broker_org_id
    })
      .then(resp => {
        console.log(resp.data);
        var _brokerList = resp.data.map(m => {
          return {
            label: m.Broker_first_name + ' ' + m.Broker_last_name,
            value: m.Broker_email
          }
        })

        this.brokerEmailList = _brokerList;

        console.log(_brokerList);

      });



    await appFunctions.crud_customerLCPolicy("getCombinedByRealmId", {
      Realm_user_id: GlobalStore.brokerObj.Realm_user_id
    })
      .then(resp => {

        var customers = resp.data.filter(data => data && data.Customer_insured_name);

        customers.sort(function (a, b) {
          return ('' + a.Customer_insured_name).localeCompare(b.Customer_insured_name);
        })



        this.customerList = customers;

      });


    this.fieldsDisabled.businessDesc = false;
    this.fieldsDisabled.contactEmail = false;
    this.fieldsDisabled.contactPhone = false;
    this.fieldsDisabled.insuredStreet = false;
    this.fieldsDisabled.insuredCity = false;
    this.fieldsDisabled.insuredState = false;
    this.fieldsDisabled.insuredPostcode = false;
    //this.fieldsDisabled.insuredName = true;
    this.fieldsDisabled.insuredABN = false;
    this.fieldsDisabled.contactFName = false;
    this.fieldsDisabled.contactLName = false;

    this.fieldsDisabled.policyStart = false;
    this.fieldsDisabled.expiryDate = false;

    this.fieldsDisabled.insuredName = false;

    this.fieldsDisabled.financier = false;


    setTimeout(async () => {
      await this.$refs.formValidator.validate();
    }, 1000);

    /*
        try {
          protecsureFunctions.getFormInitData().then(resp => {
            console.log(resp);
    
            this.formInitData = resp;
    
            this.model.policyStart = resp.periodOfCover[0].inceptionDate;
            this.model.expiryDate = resp.periodOfCover[0].expiryDate;
    
            this.model.registeredForGST = true;
    
            this.model.claimsOrLossesLast3Years = false;
            this.model.moreThan50k = false;
    
            this.model.financier = null
    
            this.isLoading = false;
    
            setTimeout(async () => {
              await this.$refs.formValidator.validate();
            }, 2000);
    
          });
        } catch {
          console.log("Could not get InitData from PS");
          this.isLoading = false;
        }
          */




    /******** temp */
    /*
    this.formInitData = {
      "periodOfCover": [
        {
          "@odata.etag": "W/\"JzQ0O0NlNW1wTFNWdWp6YlEwT3RLMUVORUt6eGlxdFhmMHBheVd5V3RVY0tIU2M9MTswMDsn\"",
          "documentType": "Quote",
          "no": "",
          "inceptionDate": "2025-04-28",
          "expiryDate": "2026-04-28",
          "periodOfCover": 12,
          "minimumInceptionDate": "2025-04-28",
          "maximumInceptionDate": "2025-05-28",
          "minimumExpiryDate": "2025-05-28",
          "maximumExpiryDate": "2027-04-28"
        }
      ],
      "equipmentExcesses": [
        {
          "@odata.etag": "W/\"JzQ0O0F3RitBNWROUElDeXRyNDBmd0pHQVpyb3dYTWxXQTVkM0hlMm02RzhVbEE9MTswMDsn\"",
          "calculationType": "Equipment",
          "excessId": 10000,
          "excessValue": 100
        },
        {
          "@odata.etag": "W/\"JzQ0O1Y5L3RxM1E4SUhHSys5T3B2T0U3NVhhRys0NVpmUGpOTUtrUHhxR0IxYTQ9MTswMDsn\"",
          "calculationType": "Equipment",
          "excessId": 30000,
          "excessValue": 500
        }
      ],
      "equipmentCategories": [
        {
          "categoryCode": "18",
          "categoryTooltip": "Dingo's, Excavators, Forklifts, Scissor Lift, Tractors, Turf Grader, Unregistered Mobile Plant & Machinery, Generators > 50KVA",
          "categoryName": "Unregistered Mobile Plant & Machinery",
          "minimumExcessAllowed": 500,
          "categoryItemId": 275
        },
        {
          "categoryCode": "2",
          "categoryTooltip": "Air Compressors > 10hp, Concrete Cutting Equipment (Cart), Concrete Mixers, Concrete Pumps, Core Drilling Equipment, Floor Polishing Equipment, Generators 10KVA > 50KVA, High Pressure Jet Washers, Jack Hammers (Pneumatic), Laser Screed, Lawn Mowers (Ride On), Portable Traffic Lights, Pumps > 20hp (Portable), Steam Cleaning Equipment (Incl. Carpet Cleaners), Transformers, Tree Stump Grinders, Water Pump, Light Machinery, Welders (>200 amps)",
          "categoryName": "Light Machinery",
          "minimumExcessAllowed": 250,
          "categoryItemId": 266
        }
      ]
    }
  
    this.model.policyStart = this.formInitData.periodOfCover[0].inceptionDate;
    this.model.expiryDate = this.formInitData.periodOfCover[0].expiryDate;
  
    this.model.registeredForGST = true;
  
    this.model.claimsOrLossesLast3Years = false;
    this.model.moreThan50k = false;
  
    this.isLoading = false;
  
  */
    /******* temp end */






    // this.formMode = this.mode;
    // this.realmApp = GlobalStore.realmApp;

    // this.policy_id = this.$route.params.id;

    // this.selectedCustomerId = 0;

    // //changeStatus();

    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://api.addressfinder.io/assets/v3/widget.js"
    // );
    // script.setAttribute("async", true);
    // script.onload = () => {
    //   this.widget = new window.AddressFinder.Widget(
    //     document.getElementById("addrs_1"),
    //     "NMY9RTVQ3UHADL76FJ8G",
    //     "AU",
    //     {
    //       address_params: {
    //         gnaf: 1
    //       }
    //     }
    //   );
    //   this.widget.on("result:select", (fullAddress, metaData) => {
    //     this.model.insuredAddress = metaData.address_line_1;
    //     this.model.insuredStreet = metaData.address_line_1;
    //     this.model.insuredCity = metaData.locality_name;
    //     this.model.insuredState = metaData.state_territory;
    //     this.model.insuredPostcode = metaData.postcode;
    //   });
    // };
    // document.head.appendChild(script);

    // console.log(this.$route.params.status);

    // if (this.$route.query.status) {
    //   this.scrollDown();
    // }
  },
  beforeDestroy() {
    if (this._motorQuoteTourDriver && this._motorQuoteTourDriver.isActive()) {
      this._motorQuoteTourDriver.destroy();
    }
  },
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    Spinner,
    ButtonRadioGroup,
    FileUpload,
    Modal,
    VehicleModal,
    AgreementModal
  },
  directives: {
    /**
     * Used ensure the keyboard is shown on mobile devices when clicking on an el-select.
     * This is because element-ui was not designed for mobile:
     * https://github.com/ElemeFE/element/issues/12742#issuecomment-420866658
     */
    cancelReadOnly(el) {
      const input = el.querySelector(".el-input__inner");
      input.removeAttribute("readonly");
    }
  }
};
</script>
<style>
.abn-link {
  font-size: 9pt;
  color: var(--uBind) !important;
  position: absolute;
  right: 0px;
  margin-right: 10px;
}

.eq-selected {
  border: 2px black solid !important;
}

.apiError {
  background-color: red !important;
  padding: 0px !important;

  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.underWritingMessages {
  background-color: orange !important;
  padding: 0px !important;

  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.validationMessages {
  background-color: #98b8cf !important;
  padding: 0px !important;

  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.less-padding {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
</style>
